import React, { Component } from "react";
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
import { ItemsCreateModal, ListPartnerModal, LocationAssignment, PartnerCreateModal, SelectOfModal, StandardSelectModal, UserFieldsModal, AddressesModal, CentroCosteModal } from ".";
import { CURRENCY, FORMAT_NUMBER, json, priceDecimalPrecision, SERVICE_RESPONSE, invFields, Modules, Granel, Envasados, development, isEntregaCilindro, isTipoConvenio, isCilindrosVaciosDevueltos, transferFields } from "../libs/utils/Const";
import moment from "moment";
import { isMarketingDocumentSAP, setDueDateFromPaymentConds } from "../libs/utils/GlobalFunc";
import AlmacenModal from "./AlmacenModal";
import PersonContactModal from "./PersonContactModal";
import config from "../config";
import Select from 'react-select';
import EmployeeSalesModal from "./EmployeeSalesModal";
import { NewItem, UserFields } from "./NewOrder";
import SeriesCreateModal from "./SeriesCreateModal";
import FormattedQueriesModal from './FormattedQueriesModal';
let apiClient = ApiClient.getInstance();
const selectStyles = {
    container: (base) => ({ ...base, flex: 1, width: '100%' }),
    control: (base) => ({
        ...base,
        height: 40,
        minHeight: 40,
        width: '100%',
        borderRadius: 4,
        backgroundColor: "transparent",
        borderColor: "#ced4da"
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    singleValue: (base) => ({ ...base, color: "#000" }),
    input: (base) => ({ ...base, color: "#000" })
};

const opcionesTipoTraslado = [
    { value: '1', label: 'Sucursal a Sucursal' },
    { value: '2', label: 'Recepción de CEDIS' },
    { value: '', label: 'Traspaso directo' }
];

const opcionesTransitType = [
    { value: 'PZ', label: 'Planta-Zonal' },
    { value: 'DZ', label: 'Distribución-Zonal' },
    { value: 'TP', label: 'Transito-Principal' },
    { value: 'DC', label: 'Distribución-Cilindros' }
];

const opcionesTipoSalida = [
    { value: '', label: '-Selecciona-' },
    { value: 'TSE', label: 'Externa' },
    { value: 'TSI', label: 'Interna' }
];

const opcionesMotivoTraslado = [
    { value: '', label: '-Selecciona-' },
    { value: '01', label: 'Venta' },
    { value: '02', label: 'Compra' },
    { value: '03', label: 'Venta con entrega a terceros' },
    { value: '04', label: 'Translado entre establecimientos de la misma empresa' },
    { value: '05', label: 'Consignación' },
    { value: '06', label: 'Devolución' },
    { value: '07', label: 'Recojo de bienes transformados' },
    { value: '08', label: 'Traslado Importacion' },
    { value: '09', label: 'Traslado Exportacion' },
    { value: '13', label: 'Otros' },
    { value: '14', label: 'Venta sujeta a confirmación del comprador' },
    { value: '17', label: 'Traslado de bienes para transformación' },
    { value: '18', label: 'Traslado emisor itenerante CP' },
    { value: '19', label: 'Traslado a zona primaria' }
];
const round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
}

class TransfersDocumentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            partners: [],
            contacts: [],
            warehouses: [],
            series: [],
            employees: [],
            items: [],
            checkboxArray: (new Map()),
            transfersListCEDIS: [],
            enableTransfersList: false,

            lineNumLocation: null,
            showLocationAssignment: false,
            optionLocation: null,
            listBinLocations: [],
            showBinLocationsModal: false,
            formattedInfo: {},
            showFormattedQueriesModal: false,
            centroCostes: [],
        };
        this.selectOfReference = null;
    }

    componentDidMount = async () => {
        const { _user } = this.state;
        await this.autoSelectEmployee(_user);
    };

    autoSelectEmployee = async (user) => {
        const { action, newOrderModel, enableSpinner } = this.props;

        if (action !== 1) {
            return;
        }

        try {
            enableSpinner(true);
            const getEmployeeResponse = await apiClient.getEmployeeList();
            enableSpinner(false);

            if (!Array.isArray(getEmployeeResponse?.data) || getEmployeeResponse.data.length === 0) {
                return;
            }

            const employees = getEmployeeResponse.data;
            const userSlpCode = user?.U_SlpCode;

            const matchedEmployee = employees.find(
                emp => emp.SlpCode === userSlpCode
            );

            if (matchedEmployee) {
                newOrderModel.SlpCode = matchedEmployee.SlpCode || '';
                newOrderModel.SlpName = matchedEmployee.SlpName || '';
                this.refreshModel(newOrderModel);
            }
        } catch (error) {
            // Error silenciado
        }
    };

    closeModal = async () => {
        $("#TransfersDocumentModal").modal("hide");
    }

    openUserFields = () => {
        const { parseSeries, view } = this.props;
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser"));
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest';

        if (isOWTRoOWTQ) {
            json.allUserFields.forEach((field) => {
                if (field.fieldType !== 3) return;

                if (field.fieldId === 1 && !field.options?.length) {
                    field.options = [
                        { value: '09', label: 'Guia' },
                        { value: 'DI', label: 'Documento Interno' },
                    ];
                }

                if (field.fieldId === 36 && !field.options?.length) {
                    let seriesPlanta = {};
                    let seriesPuerta = {};
                    try {
                        const serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                        seriesPlanta = JSON.parse(
                            serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}"
                        );
                    } catch (e) { seriesPlanta = {}; }

                    try {
                        const serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                        seriesPuerta = JSON.parse(
                            serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}"
                        );
                    } catch (e) { seriesPuerta = {}; }

                    const parsedPlanta = parseSeries(seriesPlanta);
                    const parsedPuerta = parseSeries(seriesPuerta);
                    const isZonal = Number(user?.Branch?.Type) === 1;
                    const options = isZonal ? parsedPuerta : parsedPlanta;
                    if (Array.isArray(options) && options?.length) {
                        field.options = options;
                    }
                }
            });

            this.refreshModel(this.props.newOrderModel);
        }

        $("#userFieldsModal").modal("show");
    }

    hanldeUserFields = async () => {
        const { newOrderModel } = this.props;
        this.setState({ newOrderModel });
    }

    changeField = (field, value, maxLength = 0) => {
        let { newOrderModel } = this.props;
        if (maxLength && value?.length > maxLength) return;
        newOrderModel[field] = value;
        this.refreshModel(newOrderModel);
    }

    changeAlmacenTransito = async (selectedOption, value = null) => {
        const { _user } = this.state;
        const { newOrderModel } = this.props;

        newOrderModel.U_FMB_BinLocationTr = null//RESET BINLOCATION
        if (Number(newOrderModel.Transit) === 2) { newOrderModel.CEDIS_Reception = false;}
        newOrderModel.Transit = value !== null ? value : selectedOption?.value ?? '';
        newOrderModel.DocNumCEDIS = "";
        if (Number(newOrderModel.Transit) === 2) {
            newOrderModel.WarehouseCEDIS = _user?.Branch?.ProjectCode ?? "";
            newOrderModel.Filler = "";
            newOrderModel.ToWhsCode = "";
        } else {
            newOrderModel.WarehouseCEDIS = "";
            newOrderModel.Filler = _user?.Branch?.ProjectCode || "";
        }

        if (Number(newOrderModel.Transit) === 1) {
            newOrderModel.Filler = null
            newOrderModel.TransitType = 'PZ'
        }
        this.refreshModel(newOrderModel);
    }

    changeTransitType = async (selectedOption) => {
        const { newOrderModel } = this.props;
        if (Number(newOrderModel.Transit) !== 1) { newOrderModel.TransitType = null }
        newOrderModel.TransitType = selectedOption?.value ?? null;
        this.refreshModel(newOrderModel);
    }

    change_U_BPP_MDTS = async (selectedOption) => {
        const { newOrderModel } = this.props;
        newOrderModel.U_BPP_MDTS = selectedOption?.value ?? '';

        this.refreshModel(newOrderModel);
    };

    change_U_STR_FE_GRE_CodigoMotivoTraslado = async (selectedOption) => {
        const { newOrderModel, enableSpinner, showAlert } = this.props;
        newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado = selectedOption?.value ?? '';
        const Field = 'U_STR_FE_GRE_CodigoMotivoTraslado';
        const value = selectedOption?.value ?? '';
        const linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
        if (linkedFields?.length) {
            if (value) {
                enableSpinner(true);
                let data = {
                    Field,
                    param1: value
                };
                let res = await apiClient.getFormattedQueriesByCUFD(data);
                enableSpinner(false);

                if (res?.status) {
                    const row = res?.data ?? {};

                    for (const lf of linkedFields) { // Asignar valores a campos dependientes
                        const targetField = lf.Field;

                        if (row.hasOwnProperty(targetField)) {
                            newOrderModel[targetField] = row[targetField];
                        } else {
                            newOrderModel[targetField] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo` });
                    for (const lf of linkedFields) {
                        newOrderModel[lf.Field] = '';
                    }
                }

            } else { // Limpiar dependientes
                for (const lf of linkedFields) {
                    newOrderModel[lf.Field] = '';
                }
            }
        }

        //#region U_RML_TIPOS13
        const isType13 = Number(value) === 13;

        const tipos13Field = newOrderModel?.invFields?.find(field => field?.Field === 'U_RML_TIPOS13');
        if (tipos13Field && Object.prototype.hasOwnProperty.call(tipos13Field, 'Static')) {
            tipos13Field.Static = !isType13;
        }
        if (!isType13) {
            newOrderModel.U_RML_TIPOS13 = '';
        }
        //#endregion U_RML_TIPOS13

        this.refreshModel(newOrderModel);
    };

    changeScopCode = async (event) => {
        const { newOrderModel } = this.props;
        const copyNewModel = { ...newOrderModel, U_FMB_SCOP_CODE: event.nativeEvent.target.value }
        await this.refreshModel(copyNewModel);
        this.props.scoopTools.cleanScoopFields()
    };

    changeSelectedFieldDocument = (event) => {
        const { newOrderModel } = this.props;
        let noList = event.nativeEvent.target.value;
        newOrderModel.GroupNum = parseInt(noList);

        // Precios de entrada y salida de mercancia (Ultimo precio de compra y ultimo determinado)
        noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
        newOrderModel.Items.map((item) => {
            for (let i = 0; i < item.PricesList.length; i++) {
                let list = item.PricesList[i].PriceList;
                if (list === noList) {
                    // if (newOrderModel.isTransferDocument && (Envasados?.includes(Number(item?.ItmsGrpCod)) || Granel?.includes(Number(item?.ItmsGrpCod)))) {
                    //     // No se hace nada
                    // } else {
                    item.Price = item.PricesList[i].Price;
                    item.HomePrice = item.PricesList[i].Price;
                    // }
                }
            }
            return null
        });
        this.refreshTotal(newOrderModel);
    }

    refreshModel = (newOrderModel) => {
        const { refreshModel } = this.props;
        refreshModel(newOrderModel);
        setTimeout(() => { $('body').addClass('modal-open'); }, 1000);
        setTimeout(() => {
            if ($('.modal-backdrop').length && !$('.modal.show').length) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
        }, 1200);
    }

    refreshTotal = (newOrderModel) => {
        let weightTotal = 0;
        for (const item of newOrderModel.Items) {
            weightTotal += Number(item.Weight) * Number(item.Quantity);
        }

        newOrderModel.WeightTotal = weightTotal;
        this.refreshModel(newOrderModel);
    }

    openPartner = async (index = null) => {
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        const CardCode = newOrderModel.CardCode || null;
        const type = newOrderModel?.CardType ?? 'C'

        enableSpinner(true);
        const getPartnerResponse = await apiClient.getPartner(type, CardCode, view);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse?.data?.results) || !getPartnerResponse?.data?.results?.length) {
                return showAlert({ type: "info", message: "No hay Información por mostrar" });
            }
        }

        if (getPartnerResponse.data.length === 1) {
            if (getPartnerResponse.data[0].validFor === "N") {
                this.clearSocio();
                return showAlert({ type: "error", message: "El socio de negocio se encuentra inactivo" });
            }

            await this.setState({ partners: getPartnerResponse.data, partnerType: type });
            this.selectPartner({ index: 0 });
        } else {
            this.setState({
                partners: getPartnerResponse.data.results,
                partnerType: type,
                pageTotal: getPartnerResponse.data.totalPage,
                indexPurchaseRequest: index,
            });
            $("#partnerCreate").modal("show");
        }
    }
    clearBP = () => {
        const { newOrderModel } = this.props;
        newOrderModel.partnerSelected = false;
        newOrderModel.CardCode = null
        newOrderModel.CardName = null
        newOrderModel.Email = null
        newOrderModel.DocCur = null
        newOrderModel.ChangeRate = null
        newOrderModel.SlpCode = null
        newOrderModel.SlpName = null
        newOrderModel.CntctCode = null
        newOrderModel.CntctName = null
        newOrderModel.OwnerCode = null
        newOrderModel.GroupNum = null
        newOrderModel.GroupName = null
        newOrderModel.GroupCode = null
        newOrderModel.GroupCodeName = null
        newOrderModel.PymCode = null
        newOrderModel.ExtraDays = null
        newOrderModel.PymName = null
        newOrderModel.Address = null
        newOrderModel.deliveriesAddress = []
        newOrderModel.invoicesAddress = []
        newOrderModel.ShipToCode = null
        newOrderModel.Address2 = null
        newOrderModel.PriceListNum = null
        newOrderModel.Balance = null
        newOrderModel.CreditLine = null
        newOrderModel.E_Mail = null
        newOrderModel.ItemsPayments = []
        newOrderModel.OcrCode2 = null
        newOrderModel.GroupNum = null
        newOrderModel.TaxeDefaultPartner = null
        newOrderModel.TaxeRateDefaultPartner = null
        newOrderModel.OcrCode2DefaultPartner = null
        newOrderModel.AcctCodeDefaultPartner = null
        newOrderModel.CogsAcctDefaultPartner = null
        newOrderModel.AcctCodeNameDefaultPartner = null
        newOrderModel.CogsAcctNameDefaultPartner = null
        newOrderModel.BpAct = null
        newOrderModel.BpActName = null
        newOrderModel.BpActFormatCode = null
        newOrderModel.BpActCopy = null
        newOrderModel.BpActNameCopy = null
        newOrderModel.BpActFormatCodeCopy = null
        newOrderModel.U_FMB_DescPP = null
        newOrderModel.Addresses = []
        newOrderModel.DocDueDate = null
        newOrderModel.WeightTotal = null
        setTimeout(() => {
            if ($('.modal-backdrop').length && !$('.modal.show').length) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
        }, 400);
        this.refreshModel(newOrderModel)

    }
    selectPartner = async (action) => {
        const { partners, U_FMB_DEF_PLReqStockTransfer, U_FMB_DEF_PLStockTransfer, flagAgentCode } = this.state;
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        let partner = partners[action.index];

        if (partner?.validFor === "N") {
            await this.clearSocio();
            return showAlert({ type: "error", message: "El socio de negocio se encuentra inactivo" });
        }
        $("#partnerCreate").modal("hide");
        this.setState({ partners: [] });

        try {
            enableSpinner(true);
            let getCurrencies = await apiClient.getCurrencies();
            enableSpinner(false);

            partner.Currency = partner.Currency === "##" ? CURRENCY : partner.Currency;
            let selectDocCur = getCurrencies.data.filter((currency) => currency.CurrCode === partner.Currency) || 1;
            newOrderModel.partnerSelected = true;
            newOrderModel.CardCode = partner.CardCode;
            newOrderModel.CardName = partner.CardName;
            newOrderModel.Email = partner.E_mail || "";
            newOrderModel.DocCur = partner.Currency || "";
            newOrderModel.ChangeRate = selectDocCur[0].Rate || 1;
            newOrderModel.SlpCode = partner.SlpCode || "";
            newOrderModel.SlpName = partner.SlpName || "";
            newOrderModel.CntctCode = partner.CodigoContacto || "";
            newOrderModel.CntctName = partner.Contacto || "";
            newOrderModel.OwnerCode = partner.OwnerCode || "";
            newOrderModel.GroupNum = partner.GroupNum || ""; // first Branch office Price List 
            newOrderModel.GroupName = partner.PymntGroup || "";
            newOrderModel.GroupCode = partner.GroupCode || "";
            newOrderModel.GroupCodeName = partner.GroupCodeName || "";
            newOrderModel.PymCode = partner.PymCode || "";
            newOrderModel.ExtraDays = partner.ExtraDays || 0;
            newOrderModel.PymName = partner.Descript || "";
            newOrderModel.Address = partner.Address || "";
            newOrderModel.deliveriesAddress = [];
            newOrderModel.invoicesAddress = [];
            newOrderModel.ShipToCode = "";
            newOrderModel.Address2 = "";
            newOrderModel.PriceListNum = partner.ListNum || "";
            newOrderModel.Balance = partner.Balance || "";
            newOrderModel.CreditLine = partner.CreditLine || 0;
            newOrderModel.E_Mail = partner.E_Mail;
            newOrderModel.ItemsPayments = [];
            newOrderModel.OcrCode2 = partner.OcrCode2;
            //BRANCH OFFICE CONFIG PRICE LIST
            if (view === "transfersRequest") {
                newOrderModel.GroupNum = U_FMB_DEF_PLReqStockTransfer !== null && U_FMB_DEF_PLReqStockTransfer !== undefined ? Number(U_FMB_DEF_PLReqStockTransfer) : partner.GroupNum || ""; // first Branch office Price List (REQUEST TRANSFER)
            }
            if (view === "transfers") {
                newOrderModel.GroupNum = U_FMB_DEF_PLStockTransfer !== null && U_FMB_DEF_PLStockTransfer !== undefined ? Number(U_FMB_DEF_PLStockTransfer) : partner.GroupNum || ""; // first Branch office Price List (stockTransfer)
            }
            newOrderModel.TaxeDefaultPartner = partner.TaxCode || "";
            newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
            newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || "";
            newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || "";
            newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || "";
            newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || "";
            newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || "";

            //pagos
            newOrderModel.BpAct = partner.AcctCode || "";
            newOrderModel.BpActName = partner.AcctName || "";
            newOrderModel.BpActFormatCode = partner.FormatCode || partner.BpActFormatCode;
            newOrderModel.BpActCopy = partner.AcctCode || "";
            newOrderModel.BpActNameCopy = partner.AcctName || "";
            newOrderModel.BpActFormatCodeCopy = partner.FormatCode || "";
            newOrderModel.U_FMB_DescPP = Number(partner.U_FMB_DescPP || 0);

            enableSpinner(true);
            let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
            enableSpinner(false);
            newOrderModel.deliveriesAddress = getAddressResponse.data.deliveriesAddress || [];
            newOrderModel.invoicesAddress = getAddressResponse.data.invoicesAddress || [];

            let address = [];
            let searchDefault = getAddressResponse.data.deliveriesAddress.find(address => address.Address === partner.ShipToDef);
            address = searchDefault ? searchDefault : getAddressResponse.data.deliveriesAddress[0] || [];

            newOrderModel.ShipToCode = address ? address.Address : "";
            newOrderModel.Address2 = (address.Street ? address.Street : "") + " " + (address.Block ? address.Block : "") + "  " + (address.City ? address.City : "") + " " + (address.ZipCode ? address.ZipCode : "") + " " + (address.State ? address.State : "") + " " + (address.Country ? address.Country : "") || "";

            newOrderModel.Addresses = []; // Mandar a consultar direcciones
            //Calculo fecha de entrega 
            const data = {
                GroupNum: newOrderModel.GroupNum,
                view,
                showAlert,
                model: newOrderModel,
                enableSpinner
            }
            await setDueDateFromPaymentConds(data)
            await this.refreshTotal(newOrderModel);
            //#region Precio Llamagas
            // if (newOrderModel?.isTransferDocument) { // Al cambiar de socio consultar precios
            if (false) { // Al cambiar de socio consultar precios
                setTimeout(() => {
                    this.checkItemPrices(false, true);
                }, 500);
            }
            //#endregion Precio Llamagas
        } catch (err) { showAlert({ type: "warning", message: "Información de socio incompleta, no tiene direcciónes" }); }

        //estas líneas se movieron al inicio de la función
        //$("#partnerCreate").modal("hide");
        //this.setState({ partners: [] });
    }

    refreshPartner = async (partners, pageTotal) => {
        this.setState({ partners, pageTotal });
    }

    clearSocio = async () => {
        let { newOrderModel } = this.props;

        let today = moment(new Date()).format("YYYY-MM-DD");
        newOrderModel.partnerSelected = false;
        newOrderModel.CardCode = "";
        newOrderModel.CardName = "";
        newOrderModel.SlpCode = "";
        newOrderModel.SlpName = "";
        newOrderModel.CntctCode = "";
        newOrderModel.CntctName = "";
        newOrderModel.OwnerCode = "";
        newOrderModel.GroupNum = "";
        newOrderModel.GroupName = "";
        newOrderModel.GroupCodeName = "";
        newOrderModel.PymCode = "";
        newOrderModel.PymName = "";
        newOrderModel.ExtraDays = 0;
        newOrderModel.Address = "";
        newOrderModel.deliveriesAddress = [];
        newOrderModel.invoicesAddress = [];
        newOrderModel.ShipToCode = "";
        newOrderModel.Address2 = "";
        newOrderModel.CreditLine = "";
        newOrderModel.PriceListNum = "";

        //impuesto definido desde el usuario
        newOrderModel.TaxeDefaultPartner = "";
        newOrderModel.TaxeRateDefaultPartner = 0;
        newOrderModel.OcrCode2DefaultPartner = "";
        newOrderModel.AcctCodeDefaultPartner = "";
        newOrderModel.CogsAcctDefaultPartner = "";
        newOrderModel.AcctCodeNameDefaultPartner = "";
        newOrderModel.CogsAcctNameDefaultPartner = "";

        //PAGOS RECIBIDOS Y PAGOS EFECTUADOS
        newOrderModel.TrsfrAcctFormatCode = "";
        newOrderModel.TrsfrRef = "";
        newOrderModel.TrsfrSum = "";
        newOrderModel.CheckAcctFormatCode = "";
        newOrderModel.CashAcctFormatCode = "";
        newOrderModel.CashSum = 0;
        newOrderModel.CounterRef = "";
        newOrderModel.Comments = "";
        newOrderModel.JrnlMemo = "";
        newOrderModel.ItemsPayments = [];
        newOrderModel.DocDueDate = today;

        await this.refreshTotal(newOrderModel);
        this.setState({ partners: [] });
    }

    ChangeEnableTransfersList = async () => {
        await this.setState({ enableTransfersList: !this.state.enableTransfersList })
    }

    OpenTransfers = async () => {
        const { showAlert, enableSpinner } = this.props
        const { _user } = this.state

        if (!this.state.enableTransfersList) {
            await this.ChangeEnableTransfersList();
        }

        const data = {
            DocEntry: _user?.Branch?.CodeBranchOffice ?? "",
            action: "getTransfersByCardCode"
        }

        enableSpinner(true);
        const transfersList = await apiClient.getInvoicesPorte(data);
        enableSpinner(false);

        if (!Array.isArray(transfersList.data)) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }
        if (transfersList.data.length === 0) { return showAlert({ type: "info", message: "No hay Información por mostrar" }); }

        this.setState({ transfersListCEDIS: transfersList.data });
        $("#partnerList").modal("show");
    }

    selectItemsToArray = async () => {
        const { newOrderModel, enableSpinner, showAlert } = this.props
        const { checkboxArray, transfersListCEDIS } = this.state;

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                newOrderModel.DocNumCEDIS = transfersListCEDIS[id].DocNum;
                newOrderModel.DocEntryCEDIS = transfersListCEDIS[id].DocEntry;
                newOrderModel.CEDIS_Reception = true;
                newOrderModel.Items = [];
                this.refreshModel(newOrderModel);

                const data = {
                    DocEntry: transfersListCEDIS[id].DocEntry ?? "",
                    action: "getLinesRecoverStockTransfer"
                }

                enableSpinner(true);
                const transfersList = await apiClient.getInvoicesPorte(data);
                enableSpinner(false);

                if (!Array.isArray(transfersList.data)) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }
                if (transfersList.data.length === 0) { return showAlert({ type: "info", message: "No hay Información por mostrar" }); }

                $("#partnerList").modal("hide");
                await this.setState({ enableTransfersList: false })

                showAlert({ type: "info", message: "Espera un momento, estamos cargando tu informacion, te notificare cuando puedas continuar", timeOut: 5000 });
                for (const element of transfersList.data) {
                    enableSpinner(true);
                    await this.openItems(element.ItemCode);
                    enableSpinner(false);
                }
                enableSpinner(true);
                setTimeout(async () => {
                    // enableSpinner(true);
                    let cont = 0;
                    for (const element of transfersList.data) {
                        await this.changeQuantityItem(null, cont, element.Quantity)
                        cont++;
                    }
                    enableSpinner(false);
                    showAlert({ type: "success", message: "Listo, gracias por la espera, continua el proceso por favor", timeOut: 3000 });
                }, 2000);
            }
        }
    }

    openPersonContact = async () => {
        const { showAlert, newOrderModel, enableSpinner } = this.props;
        if (!newOrderModel.CardName) { return showAlert({ type: "info", message: "Selecciona un socio de negocios" }); }

        enableSpinner(true);
        let getContactsResponse = await apiClient.getContactsList(newOrderModel.CardCode);
        enableSpinner(false);

        if (!Array.isArray(getContactsResponse.data)) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }
        if (getContactsResponse.data.length === 0) { return showAlert({ type: "info", message: "No hay Información por mostrar" }); }

        await this.setState({ contacts: getContactsResponse.data });
        $("#personContactModal").modal("show");
    }

    selectContact = (action) => {
        const { contacts } = this.state;
        const { newOrderModel } = this.props;
        let contact = contacts[action.index];

        newOrderModel.CntctCode = contact.CntctCode || "";
        newOrderModel.CntctName = contact.CntctName || "";

        this.refreshModel(newOrderModel);
        $("#personContactModal").modal("hide");
        this.setState({ contacts: [] })
    }

    SearchAlmacen = async (index, warehouse, itemCode = null) => {
        const { showAlert, enableSpinner, view, newOrderModel } = this.props;

        let data = {
            TransferType: null,
            ItemCode: null,
            whsCode: "",
            view,
            TransitType: newOrderModel?.TransitType,
            warehouse,
            Transit: newOrderModel?.Transit,
        }

        enableSpinner(true);
        const getAlmacenResponse = await apiClient.getWarehouseList(data);
        enableSpinner(false);

        if (!Array.isArray(getAlmacenResponse.data)) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }
        if (getAlmacenResponse.data.length === 0) { return showAlert({ type: "info", message: "El Artículo no existe en los almacenes configurados para la sucursal actual" }); }

        if (getAlmacenResponse.data.length === 1) {
            await this.setState({
                warehouses: getAlmacenResponse.data,
                itemOrderModelUpdate: index,
                warehouseUpdate: warehouse,
            });

            this.selectAlmacen({ index: 0 });
        } else {
            this.setState({
                warehouses: getAlmacenResponse.data,
                itemOrderModelUpdate: index,
                warehouseUpdate: warehouse,
                itemSelected: itemCode
            });
            $("#almacenDocumentsModal").modal("show");
        }
    }

    selectAlmacen = async (action) => {
        const { warehouses, warehouseUpdate } = this.state;
        const { newOrderModel, showAlert, enableSpinner, view } = this.props;
        let warehouse = warehouses[action.index];
        let checkPrice = false

        //ALMACEN ORIGEN
        if (warehouseUpdate === 2) {
            newOrderModel.Filler = warehouse.WhsCode || "";
            newOrderModel.FillerName = warehouse.WhsName || "";
            const U_FMB_Factor_Conversion = Number(warehouse?.U_FMB_Factor_Conversion || 0);

            //#region DIMENSIONS
            if (newOrderModel?.isTransferDocument && newOrderModel.DocType === 'I' && newOrderModel?.Items?.length) { // Al cambiar de almacén ajustar los códigos OcrCode2 y OcrCode3
                const isTransfersRequest = view === "transfersRequest" || newOrderModel?.newView === "transfersRequest";
                enableSpinner(true);
                const data = {
                    Type: 2,
                    filter1: warehouse?.WhsCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                for (let item of newOrderModel?.Items) {
                    item.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                    item.OcrName2 = isTransfersRequest ? (apiResponse?.data?.Dimension2Name || '') : '';
                    item.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                    item.OcrName3 = isTransfersRequest ? (apiResponse?.data?.Dimension3Name || '') : '';

                    item.Dimension2 = item.OcrCode2 ? true : false;
                    item.Dimension3 = item.OcrCode3 ? true : false;
                }
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" de los artículo ha sido ajustado al cambiar de almacén`, timeOut: 8000 });
            }
            //#endregion DIMENSIONS

            for (let item of newOrderModel.Items) {
                //#region Precio Llamagas
                // if (newOrderModel?.isTransferDocument) {
                if (false) {
                    const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = item ?? {}
                    const envasado = Envasados?.includes(Number(ItmsGrpCod));
                    const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                    let searchItem = ItemCode;

                    if (!isTemporary && searchItem && (envasado || glpGranel)) {
                        let getItemResponse = null;
                        let data = {
                            CardCode: newOrderModel?.CardCode || "",
                            ItemCode: searchItem || "",
                            WhsCode: newOrderModel?.Filler || '',
                            ShipToCode: newOrderModel?.ShipToCode || "",
                            userFields: newOrderModel?.userFields || {},
                            Quantity,
                            U_RS_CANTG,
                            U_RS_UMED,
                            U_RS_PRECIOGL,
                            gallonsPrice: true,
                        };

                        //#region GALLON PRICE
                        enableSpinner(true);
                        let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);
                        const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                        data.U_RS_PRECIOGL = U_RS_PRECIO;
                        data.gallonsPrice = false;
                        //#endregion GALLON PRICE

                        enableSpinner(true);
                        getItemResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);

                        const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                        item.Price = U_RS_CALCULADO;
                        checkPrice = true;

                        if (glpGranel) {
                            item.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                            item.U_RS_TOTALGL = Number((Number(item?.U_RS_PRECIOGL || 0) * Number(item?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                        }

                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                            item.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                            item.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                        } else {
                            item.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                            item.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        }

                        item.newHomePrice = item.Price || 0;
                        item.newPrice = item.Price || 0;
                        item.cHomePrice = item.Price || 0;
                        item.cPrice = item.Price || 0;
                        if (getItemResponse?.status === 1) {
                            showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar de almacén.', timeOut: 5000 });
                        } else {
                            showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar de almacén.', timeOut: 5000 });
                        }
                    }
                }
                //#endregion Precio Llamagas

                //#region GALLONS CONVERSION
                if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && Granel?.includes(Number(item?.ItmsGrpCod))) {
                    item.U_RS_DENS = U_FMB_Factor_Conversion;
                }
                // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && item?.Gallons &&
                if ((newOrderModel?.isSalesDocument) && item?.Gallons &&
                    Number(item?.U_RS_CANTG) > 0 &&
                    item?.U_RS_UMED === 'GLN' &&
                    // (view === 'quotations' || view === 'orderSales' || view === 'draft' || newOrderModel?.isTransferDocument)
                    (view === 'quotations' || view === 'orderSales' || view === 'draft')
                ) {
                    // Al cambiar de almacén volver a consultar la conversion a galones
                    item = await this.checkGallons(item, null, newOrderModel.Filler);
                    checkPrice = true;
                }
                //#endregion GALLONS CONVERSION

                item.stock = true;
                item.TotalAsigned = 0;
                item.Filler = newOrderModel.Filler;
                item.FillerWhs = Array.isArray(item?.wareHouseStock) ? item.wareHouseStock.find(({ WhsCode }) => WhsCode === newOrderModel?.Filler) : {};
                item.FromLocationAssignment = Array.isArray(item.FillerWhs?.Location) ? item.FillerWhs.Location : [];
                const onHand = Number(item?.FillerWhs?.OnHand || 0);

                if (!onHand) {
                    showAlert({ type: "warning", message: `El artículo ${item.ItemCode} ya no tiene existencia en el almacén de Origen` });
                    item.stock = false;
                }

                //#region ########## BINS ##########
                if (item.FromLocationAssignment.length === 1) {
                    let location = item.FromLocationAssignment[0];
                    if (Number(item.Quantity) <= (Number(location.OnHandQty) || 0)) {
                        item.TotalAsigned = Number(item.Quantity).toFixed(3);
                        location.Quantity = Number(item.Quantity).toFixed(3);
                        location.remainingQty = (Number(location.OnHandQty) - Number(item.Quantity)).toFixed(3);
                    } else {
                        item.TotalAsigned = (Number(location.OnHandQty) || 0).toFixed(3);
                        location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                        location.remainingQty = "0.000";
                    }
                } else if (item.FromLocationAssignment.length && Number(item.Quantity) === Number(item.FillerWhs?.OnHand || 0)) {
                    item.TotalAsigned = Number(item.FillerWhs?.OnHand || 0).toFixed(3);

                    for (let location of item.FromLocationAssignment) {
                        location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                        location.remainingQty = "0.000";
                    }
                }
                //#endregion

            }
        }

        //ALMACEN DESTINO
        if (warehouseUpdate === 3) {
            newOrderModel.ToWhsCode = warehouse.WhsCode || "";
            newOrderModel.ToWhsCodeName = warehouse.WhsName || "";

            for (let item of newOrderModel.Items) {
                item.ToWhsCode = newOrderModel.ToWhsCode;
                item.ToWhs = Array.isArray(item?.wareHouseStock) ? item.wareHouseStock.find(({ WhsCode }) => WhsCode === newOrderModel?.ToWhsCode) : {};
                item.ToLocationAssignment = [];
                item.ToTotalAsigned = 0;

                if (item.ToWhs?.BinActivat === "Y") {
                    enableSpinner(true);
                    const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                    enableSpinner(false);

                    item.ToLocationAssignment = Array.isArray(ubication?.data?.results) ? ubication.data.results : [];
                    if (item.ToLocationAssignment.length) {
                        item.ToTotalAsigned = Number(item.Quantity).toFixed(3);
                        item.ToLocationAssignment[0].Quantity = Number(item.Quantity).toFixed(3);
                    }
                }
            }
        }

        //CEDIS
        if (warehouseUpdate === 117) {
            newOrderModel.WarehouseCEDIS = warehouse.WhsCode;
        }

        await this.refreshModel(newOrderModel);
        $("#almacenDocumentsModal").modal("hide");
        this.setState({ warehouses: [], itemOrderModelUpdate: null, itemSelected: "" });
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    }

    openSeries = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (!newOrderModel?.SerieArray?.length) { return showAlert({ type: "info", message: "No hay Información por mostrar" }); }

        await this.setState({ series: newOrderModel.SerieArray });
        $("#seriesDocumentsModal").modal("show");
    }

    selectSeries = (action) => {
        const { newOrderModel } = this.props;
        let serie = newOrderModel.SerieArray[action.index];
        newOrderModel.SerieName = serie.SeriesName || "";
        newOrderModel.SerieCode = serie.Series || "";
        newOrderModel.NextFolio = serie.NextNumber || "";
        this.refreshModel(newOrderModel);

        $("#seriesDocumentsModal").modal("hide");
        this.setState({ series: [] });
    }

    openEmployee = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let getEmployeeResponse = await apiClient.getEmployeeList();
        enableSpinner(false);

        if (!Array.isArray(getEmployeeResponse.data)) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }
        if (getEmployeeResponse.data.length === 0) { return showAlert({ type: "info", message: "No hay Información por mostrar" }); }

        this.setState({ employees: getEmployeeResponse.data });
        $("#employeeDocumentsModal").modal("show");
    }

    selectEmployee = action => {
        const { employees } = this.state;
        const { newOrderModel } = this.props;
        let employee = employees[action.index];

        newOrderModel.SlpCode = employee.SlpCode || "";
        newOrderModel.SlpName = employee.SlpName || "";

        this.refreshModel(newOrderModel);
        $("#employeeDocumentsModal").modal("hide");
        this.setState({ employees: [] });
    }

    openItems = async () => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        let searchItem = newOrderModel?.searchItem || "";

        if (!newOrderModel.Filler) { return showAlert({ type: "info", message: "Selecciona un almacén de origen" }); }
        if (!newOrderModel.ToWhsCode) { return showAlert({ type: "info", message: "Selecciona un almacén de destino" }); }

        enableSpinner(true);
        const getItemResponse = await apiClient.getItem(newOrderModel.CardCode, searchItem === "CASCOSEARCH" ? searchItem : view, searchItem, newOrderModel);
        enableSpinner(false);

        if (!getItemResponse?.data?.results?.length && !getItemResponse?.data?.length) {
            return showAlert({ type: "info", message: "No hay Información por mostrar" });
        }

        if (getItemResponse.data.length === 1) {
            await this.setState({ items: getItemResponse.data });
            this.selectItems(getItemResponse.data);
        } else {
            this.setState({
                items: getItemResponse?.data?.results || getItemResponse?.data || [],
                pageTotal: getItemResponse?.data?.totalPage || getItemResponse?.data?.length || 0
            });
            $("#itemsCreate").modal("show");
        }
    }

    refreshItems = async (items, pageTotal) => {
        this.setState({ items, pageTotal });
    }

    selectItems = async (itemsSelected) => {
        const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        for (const item of itemsSelected) {
            const newItemModel = new NewItem();
            newItemModel.LineNum = newOrderModel.Items.length;
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Quantity = 1;
            newItemModel.QuantityFotmat = Number(newItemModel.Quantity).toFixed(3);

            let noList = parseInt(newOrderModel.GroupNum);
            noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
            let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

            newItemModel.Price = price?.[0]?.Price ?? 0;
            newItemModel.HomePrice = price?.[0]?.Price ?? 0;
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.AvgPrice = item.AvgPrice;
            newItemModel.ManBtchNum = item.ManBtchNum;
            newItemModel.UserFieldsItem = JSON.parse(JSON.stringify(newOrderModel.userFieldsItem));

            newItemModel.stock = true;
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.Filler = newOrderModel.Filler;
            newItemModel.FillerWhs = Array.isArray(item?.wareHouses) ? item.wareHouses.find(({ WhsCode }) => WhsCode === newOrderModel?.Filler) : {};
            newItemModel.FromLocationAssignment = Array.isArray(newItemModel.FillerWhs?.Location) ? newItemModel.FillerWhs.Location : [];
            newItemModel.ToWhsCode = newOrderModel.ToWhsCode;
            newItemModel.ToWhs = Array.isArray(item?.wareHouses) ? item.wareHouses.find(({ WhsCode }) => WhsCode === newOrderModel?.ToWhsCode) : {};

            if (!newItemModel?.FillerWhs?.OnHand) {
                showAlert({ type: "warning", message: `El artículo ${item.ItemCode} ya no tiene existencia en el almacén de Origen` });
                newItemModel.stock = false;
            }
            // Cargar campo para valdar SCOP
            newItemModel.U_RS_NEGNR = item.U_RS_NEGNR || '';

            //#region ########## BINS ##########
            newItemModel.TotalAsigned = 0;
            newItemModel.ToTotalAsigned = 0;

            if (newItemModel.FromLocationAssignment.length === 1) {
                let location = newItemModel.FromLocationAssignment[0];
                if (Number(newItemModel.Quantity) <= (Number(location.OnHandQty) || 0)) {
                    newItemModel.TotalAsigned = Number(newItemModel.Quantity).toFixed(3);
                    location.Quantity = Number(newItemModel.Quantity).toFixed(3);
                    location.remainingQty = (Number(location.OnHandQty) - Number(newItemModel.Quantity)).toFixed(3);
                } else {
                    newItemModel.TotalAsigned = (Number(location.OnHandQty) || 0).toFixed(3);
                    location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                    location.remainingQty = "0.000";
                }
            } else if (newItemModel.FromLocationAssignment.length && Number(newItemModel.Quantity) === Number(item.FillerWhs?.OnHand || 0)) {
                newItemModel.TotalAsigned = Number(item.FillerWhs?.OnHand || 0).toFixed(3);

                for (let location of newItemModel.FromLocationAssignment) {
                    location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                    location.remainingQty = "0.000";
                }
            }

            if (newItemModel.ToWhs?.BinActivat === "Y") {
                enableSpinner(true);
                const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                enableSpinner(false);

                newItemModel.ToLocationAssignment = Array.isArray(ubication?.data?.results) ? ubication.data.results : [];
                if (newItemModel.ToLocationAssignment.length) {
                    newItemModel.ToTotalAsigned = Number(newItemModel.Quantity).toFixed(3);
                    newItemModel.ToLocationAssignment[0].Quantity = Number(newItemModel.Quantity).toFixed(3);
                }
            }
            //#endregion

            if (isMarketingDocumentSAP(view)) {
                if (newOrderModel.searchItem == "CASCOSEARCH" && item?.U_FMB_IS_CILINDRO === "1") {
                    newItemModel.Quantity = newOrderModel.Items[newOrderModel.indexSearch].Quantity;
                    delete newOrderModel.indexSearch;
                }

                newItemModel.Casco = 1;
                newItemModel.U_FMB_CILINDRO = item?.U_FMB_CILINDRO || newItemModel.U_FMB_CILINDRO;
                newItemModel.U_FMB_IS_CILINDRO = item?.U_FMB_IS_CILINDRO || newItemModel.U_FMB_IS_CILINDRO;
            }

            newItemModel.ItmsGrpCod = item.ItmsGrpCod;

            let checkPrice = false;
            //#region Precio Llamagas
            // if (newOrderModel?.isTransferDocument) {
            if (false) {
                let searchItem = newItemModel?.ItemCode;
                const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

                if (!newItemModel?.isTemporary && (envasado || glpGranel)) {
                    if (!newOrderModel?.Filler) {
                        showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén origen para obtener el precio del artículo ${newItemModel?.ItemCode || newItemModel.ItemName}`, timeOut: 5000 });
                    }
                    let getItemResponse = null;
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.Filler || "",
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity: newItemModel?.Quantity || 0,
                        U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                        U_RS_UMED: newItemModel?.U_RS_UMED || "",
                        U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                        gallonsPrice: true,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    if (newOrderModel?.Filler) {
                        getItemResponse = await apiClient.getPriceListLlama(data);
                    }
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    const item = newItemModel || {};
                    item.Price = U_RS_CALCULADO;
                    checkPrice = true;

                    if (glpGranel) {
                        newItemModel.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0).toFixed(priceDecimalPrecision));
                        newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    newItemModel.newHomePrice = item.Price || 0;
                    newItemModel.newPrice = item.Price || 0;
                    newItemModel.cHomePrice = item.Price || 0;
                    newItemModel.cPrice = item.Price || 0;

                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: `El precio del artículo ${newItemModel.ItemCode || newItemModel.ItemName} ha sido ajustado por el grupo de artículos al que pertenece`, timeOut: 5000 });
                    } else if (newOrderModel?.Filler) {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode, timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas

            //#region GALLONS CONVERSION
            newItemModel.U_RS_UMED = item.U_RS_UMED || '';
            newItemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
            newItemModel.U_RS_PRECIOGL = checkPrice ? Number(newItemModel.U_RS_PRECIOGL || 0) : Number(item.U_RS_PRECIOGL || 0);
            if (development && !newItemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
                newItemModel.U_RS_PRECIOGL = 100;
            }
            newItemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
            newItemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
            try {
                if (newOrderModel?.Filler && Granel?.includes(Number(newItemModel?.ItmsGrpCod))) {
                    enableSpinner(true);
                    const data = {
                        WhsCode: newOrderModel?.Filler,
                    };
                    const apiResponse = await apiClient.getFactorConversion(data);
                    enableSpinner(false);

                    if (apiResponse?.status === 1) {
                        newItemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                    }
                }
            } catch (err) { }
            newItemModel.Gallons = item.Gallons || 0;
            //#endregion GALLONS CONVERSION

            //#region DIMENSIONS
            enableSpinner(true);
            const data = {
                Type: 6,
                filter1: newOrderModel?.isTransferDocument ? newOrderModel?.Filler || '' : newItemModel.WhsCode || '',
                filter2: newItemModel.ItemCode || '',
            };
            const apiResponse = await apiClient.getDimensions(data);
            enableSpinner(false);

            if (apiResponse?.status === 1) {
                newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || ''; // Determinado desde el almacén
                newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || ''; // Determinado desde el almacén
                newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || ''; // Determinado desde el artículo
                newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || ''; // Determinado desde el artículo

                newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
                newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;

                newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
                newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
            }
            //#endregion DIMENSIONS

            newOrderModel.Items.push(newItemModel);
        }

        newOrderModel.searchItem = "";
        await this.refreshTotal(newOrderModel);
        $("#itemsCreate").modal("hide");
        this.setState({ items: [] });
    }

    deleteItem = async (indexToDelete) => {
        const { newOrderModel } = this.props;
        let newItems = [];
        let hasBaseEntry = false;

        if (newOrderModel?.Items?.[indexToDelete]?.U_FMB_IS_CILINDRO === "1") { return; }


        newOrderModel.Items.forEach((item, index) => {
            if (indexToDelete !== index) {
                if (item.BaseEntry) { hasBaseEntry = true; }
                if (!((item?.U_FMB_IS_CILINDRO ?? "") === "1" && (item?.U_FMB_CILINDRO ?? "") === newOrderModel.Items[indexToDelete].ItemCode && newOrderModel.Items[indexToDelete].WhsCode === item.WhsCode && newOrderModel.Items[indexToDelete].Quantity === item.Quantity)) {
                    newItems.push(item);
                }
            }
        });

        newOrderModel.isSelectTo = hasBaseEntry;
        newOrderModel.Items = newItems;

        if (newOrderModel.Items.length === 0) { this.props.scoopTools.cleanScoopFields(); }
        this.refreshTotal(newOrderModel);
    }

    changeQuantityItem = (index, value, specifQty = null) => {
        let { newOrderModel } = this.props;
        const orgValue = specifQty || value;
        value = `${orgValue}`.replace(/,/g, "");

        if (isNaN(value)) { return; }

        newOrderModel.Items[index].Quantity = Number(value || 0);
        newOrderModel.Items[index].QuantityFotmat = specifQty ? FORMAT_NUMBER.new(orgValue, "", 3) : orgValue;
        this.refreshTotal(newOrderModel, index);
    }

    validateQty = async (index, value, Gallons = false) => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        let item = newOrderModel.Items[index];
        const onHand = item.FillerWhs?.OnHand || 0;
        if (isNaN(value)) { value = 0; }

        if (Number(onHand) < Number(value)) {
            showAlert({ type: "warning", message: "La cantidad en el almacén de origen no puede caer en negativo" });
            //value = Number(onHand);
        }

        value = Number(value).toFixed(3);
        item.Quantity = Number(value || 0);
        item.QuantityFotmat = FORMAT_NUMBER.new(value, "", 3);
        item.stock = Number(onHand) >= Number(value);

        //#region ########## BINS ##########
        if (item.FromLocationAssignment.length === 1) {
            let location = item.FromLocationAssignment[0];
            if (Number(item.Quantity) <= (Number(location.OnHandQty) || 0)) {
                item.TotalAsigned = Number(item.Quantity).toFixed(3);
                location.Quantity = Number(item.Quantity).toFixed(3);
                location.remainingQty = (Number(location.OnHandQty) - Number(item.Quantity)).toFixed(3);
            } else {
                item.TotalAsigned = (Number(location.OnHandQty) || 0).toFixed(3);
                location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                location.remainingQty = "0.000";
            }
        } else if (item.FromLocationAssignment.length && Number(value) === Number(onHand)) {
            item.TotalAsigned = Number(value).toFixed(3);

            for (let location of item.FromLocationAssignment) {
                location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                location.remainingQty = "0.000";
            }
        }

        if (item.ToLocationAssignment.length === 1) {
            item.ToTotalAsigned = Number(item.Quantity).toFixed(3);
            item.ToLocationAssignment[0].Quantity = Number(item.Quantity).toFixed(3);
        }
        //#endregion

        if (Gallons) {
            //#region Precio Llamagas
            // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
            if ((newOrderModel?.isSalesDocument)) {
                const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = item ?? {}
                const envasado = Envasados?.includes(Number(ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                let searchItem = ItemCode;

                if (!isTemporary && searchItem && (envasado || glpGranel)) {
                    let getItemResponse = null;
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: searchItem || "",
                        WhsCode: newOrderModel?.Filler || "",
                        ShipToCode: newOrderModel?.ShipToCode || "",
                        userFields: newOrderModel?.userFields || {},
                        Quantity,
                        U_RS_CANTG,
                        U_RS_UMED,
                        U_RS_PRECIOGL,
                        gallonsPrice: true,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    getItemResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);

                    const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                    item.Price = U_RS_CALCULADO;

                    if (glpGranel) {
                        item.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                        item.U_RS_TOTALGL = Number((Number(item?.U_RS_PRECIOGL || 0) * Number(item?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    }

                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                        item.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                        item.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                    } else {
                        item.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        item.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    }

                    item.newHomePrice = item.Price || 0;
                    item.newPrice = item.Price || 0;
                    item.cHomePrice = item.Price || 0;
                    item.cPrice = item.Price || 0;
                    if (getItemResponse?.status === 1) {
                        showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la cantidad de galones.', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la cantidad de galones.', timeOut: 5000 });
                    }
                }
            }
            //#endregion Precio Llamagas
        }

        this.refreshTotal(newOrderModel, index);
    }

    showLocationAssignment = async (lineNum, option) => {
        await this.setState({ lineNumLocation: lineNum, showLocationAssignment: true, optionLocation: option });
        $("#locationAssignment").modal("show");
        $("#locationAssignment").on("hidden.bs.modal", () => {
            if (option === 2) {
                const { newOrderModel } = this.props;
                let item = newOrderModel.Items[lineNum];
                item.ToLocationAssignment = item.ToLocationAssignment.filter(({ Quantity }) => !!Number(Quantity || 0));
                this.refreshTotal(newOrderModel);
            }
        });
    }

    openLocations = async (positionToLocation = null) => {
        const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        let searchLocation = newOrderModel.searchLocation;
        let ToWhsCode = newOrderModel.ToWhsCode || "";

        this.setState({
            showOptions: false
        })
        let getLocationResponse = null;
        enableSpinner(true);
        getLocationResponse = await apiClient.getLocations(searchLocation, 1, 10, ToWhsCode);
        enableSpinner(false);

        if (getLocationResponse.data.length === 0) {

            if (!Array.isArray(getLocationResponse.data.results)) {
                showAlert({ type: "info", message: getLocationResponse.message });
                return;
            }

            if (getLocationResponse.data.length === 0) {
                showAlert({ type: "info", message: "No hay Información por mostrar" });
                return;
            }
        }
        if (view === "inventoryPosting") {
            this.setState({
                positionLine: positionToLocation,
            });
        }
        if (getLocationResponse.data.results.length === 1) {
            this.setState({
                locations: getLocationResponse.data.results,
            });
            await this.selectLocationsEnter(getLocationResponse.data.results[0], positionToLocation);
        } else {
            this.setState({
                showListLocationsModal: true,
                locations: getLocationResponse.data.results,
                pageTotal: getLocationResponse.data.totalPage
            });
            $("#listLocations").modal("show");
        }
    }

    changeSearchLocations = async (event) => {
        const { newOrderModel } = this.props;
        newOrderModel.searchLocation = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    }

    openLocationDetails = async (AbsEntry) => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getLocation(AbsEntry);
        enableSpinner(false);
        if (responseApi.status === 0) { return showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" }); }

        await this.setState({ locationModel: responseApi.data[0], showLocationModal: true });
        $("#locationModal").modal("show");
    }

    selectLocationsEnter = async (data, positionToLocation) => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.Items[positionToLocation].ToLocationAssignment?.some(toLocation => toLocation.AbsEntry === data.AbsEntry)) { return showAlert({ type: "warning", message: "No se puede agregar ubicaciones que ya existen" }); }
        newOrderModel.Items[positionToLocation].ToLocationAssignment.push(data);

        newOrderModel.searchLocation = "";
        await this.refreshModel(newOrderModel);
        this.setState({ showListLocationsModal: false });
    }

    openFormattedQueries = async field => {
        this.setState({
            formattedInfo: field ?? {},
            showFormattedQueriesModal: true,
        }, () => {
            $('#formattedQueriesModal').modal('show');
        }
        );
    };

    selectFormattedQueries = async (action) => {
        const { formattedInfo } = this.state;
        const { newOrderModel, enableSpinner, showAlert, view } = this.props;
        let Field = formattedInfo?.Field ?? '';
        if (!Field) {
            return;
        }
        let currentData = newOrderModel?.formattedMap?.[Field] ?? [];
        let value = Object.values(currentData?.[action?.index] ?? {})[0] ?? '';
        newOrderModel[Field] = value;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001;

        const linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
        if (linkedFields?.length) {
            if (value) {
                enableSpinner(true);
                let data = {
                    Field,
                    param1: value
                };
                let res = await apiClient.getFormattedQueriesByCUFD(data);
                enableSpinner(false);

                if (res?.status) {
                    const row = res?.data ?? {};

                    for (const lf of linkedFields) { // Asignar valores a campos dependientes
                        const targetField = lf.Field;

                        if (row.hasOwnProperty(targetField)) {
                            newOrderModel[targetField] = row[targetField];
                        } else {
                            newOrderModel[targetField] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo "${formattedInfo?.Name}"` });
                    for (const lf of linkedFields) {
                        newOrderModel[lf.Field] = '';
                    }
                }

            } else { // Limpiar dependientes
                for (const lf of linkedFields) {
                    newOrderModel[lf.Field] = '';
                }
            }
        }

        if (isOWTRoOWTQ) {
            if (Field === 'U_RML_TIPOS13') {
                const CodigoMotivoTraslado = newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado;
                if (CodigoMotivoTraslado === '13') {
                    const tipos13Field = newOrderModel?.formattedMap?.[Field] ?? [];
                    const tipos13FieldCode = Object.keys(tipos13Field?.[0] || {})[0];
                    const tipos13FieldDesc = Object.keys(tipos13Field?.[0] || {})[1];
                    let tipos13Desc = tipos13Field.find(option => option[tipos13FieldCode] === value)?.[tipos13FieldDesc] || '';

                    enableSpinner(true);
                    let data = {
                        Field: 'U_STR_FE_GRE_CodigoMotivoTraslado',
                        param1: CodigoMotivoTraslado
                    };
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);
                    const row = res?.data ?? {};
                    newOrderModel.U_STR_FE_GRE_DescriMotivoTraslado = tipos13Desc ? `${row?.U_STR_FE_GRE_DescriMotivoTraslado || ''}: ${tipos13Desc}` : row?.U_STR_FE_GRE_DescriMotivoTraslado || '';
                    await this.refreshModel(newOrderModel);
                }
            }
        }

        $('#formattedQueriesModal').modal('hide');
        setTimeout(() => {
            this.setState({
                formattedInfo: {},
                showFormattedQueriesModal: false
            });
        }, 100);

        await this.refreshModel(newOrderModel);
    };

    refreshLocations = async (locations, pageTotal, searchLocation) => {
        const { newOrderModel } = this.props;
        newOrderModel.searchLocation = searchLocation;
        await this.setState({ locations, pageTotal });
        this.refreshModel(newOrderModel);
    }

    originDocuments = (currentView) => {
        let copyFields = false;
        switch (currentView) {
            case 'transfersRequest':
            case 'transfers':
                copyFields = true
                break;

            default:
                break;
        }
        return copyFields;
    }

    selectionDocument = (select) => {
        let copyFields = false;
        switch (select) {
            case 'transfers':
            case 'transfersRequest':
                copyFields = true
                break;

            default:
                break;
        }
        return copyFields;
    }

    selectOf = async (value) => {
        const { newOrderModel } = this.props;
        newOrderModel.SelectOf = value || '';
        this.refreshModel(newOrderModel);
        this.selectOfReference.enableDataTable();
        $('#selectOfModal').modal('show');
    }

    selectOfDocuments = async (documentsSelected) => {
        const { showAlert, enableSpinner, setUserFieldValue, view, parseSeries, processUserFields, processUserFieldsDetails } = this.props;
        let newOrderModel = JSON.parse(JSON.stringify(this.props.newOrderModel));
        let BaseType;
        let DocEntry;
        let header = documentsSelected?.[0]?.header || {};
        let userFieldsService = documentsSelected[0] ? documentsSelected[0].userFields : [];

        const today = moment(new Date()).format('YYYY-MM-DD');

        newOrderModel.DocDueDate = today;
        newOrderModel.isSelectTo = true;
        newOrderModel.isSelectOfActive = true;

        //#region copy userfields
        let copyUserFields = false;
        if (this.selectionDocument(newOrderModel.SelectOf) && this.originDocuments(view)) {
            copyUserFields = true;
        }
        //#region copy userfields

        for (let index = 0; index < documentsSelected.length; index++) {
            const document = documentsSelected[index];
            if (index === 0) {
                newOrderModel.Address = document.header.Address;
                newOrderModel.Filler = document.header.Filler;
                newOrderModel.FillerName = document.header.FromWhsName || "";
                newOrderModel.PickRmrk = document.header.PickRmrk || '';
                newOrderModel.ToWhsCode = document.header.ToWhsCode || '';
                newOrderModel.ToWhsCodeName = document.header.ToWhsName || "";
                newOrderModel.JrnlMemo = document.header.JrnlMemo;
                newOrderModel.Comments += `${newOrderModel.Comments ? ", " : ""}Basado en Solicitud de traslado ${document.header.DocNum}`;
                newOrderModel.GroupNumTraslado = document.header.GroupNum;
                newOrderModel.GroupNumTrasladoName = document.header.ListName;

                newOrderModel.CardCode = document.header.CardCode || '';
                newOrderModel.CardName = document.header.CardName || '';
                newOrderModel.SlpCode = document.header.SlpCode;
                newOrderModel.SlpName = document.header.SlpName;
                newOrderModel.CntctCode = document.header.CntctCode;
                newOrderModel.CntctName = document.header.CntntName;
                newOrderModel.GroupNum = document.header.GroupNum;
                newOrderModel.ShipToCode = document.header.ShipToCode;
                newOrderModel.Address2 = document.header.Address2;

                let userFields = new UserFields();
                json.allUserFields.forEach((item, index) => {
                    userFieldsService.forEach((userfieldItem) => {
                        if (item.fieldId === userfieldItem.header.FieldID) {
                            item.name = userfieldItem.header.Descr;
                            item.fieldType = userfieldItem.options.length !== 0 ? 2 : 1;
                            item.options = userfieldItem.options;
                            item.IdValue = index;
                            let newUserFields = setUserFieldValue(userFields, index, document.header);
                            if (item.fieldType === 2) {
                                item.options.push({ FldValue: "", Descr: "" });
                            }
                            userFields = newUserFields;
                        }
                    });
                });

                newOrderModel.userFields = userFields;
                //#region ################## LLAMAGAS ################ ✔
                newOrderModel.U_BPP_MDTS = document.header?.U_BPP_MDTS;
                newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado = document.header?.U_STR_FE_GRE_CodigoMotivoTraslado;
                newOrderModel.U_FMB_SCOP_CODE = document.header?.U_FMB_SCOP_CODE ?? null;
                newOrderModel.U_STR_FE_GRE_DescriMotivoTraslado = document.header?.U_STR_FE_GRE_DescriMotivoTraslado ?? null;
                //#endregion ################## LLAMAGAS ################ ✔
            }

            BaseType = document.header.ObjType;
            DocEntry = document.header.DocEntry;

            for (const item of document.items) {
                if (item.LineStatus == 'O') {
                    let itemModel = new NewItem();

                    itemModel.LineStatus = false;
                    itemModel.BaseEntry = DocEntry;
                    itemModel.BaseType = BaseType;
                    itemModel.BaseLine = item.LineNum;

                    itemModel.LineNum = newOrderModel.Items.length;
                    itemModel.ItemCode = item.ItemCode;
                    itemModel.ItemName = item.Dscription;
                    itemModel.Quantity = item.OpenQty || 1;
                    itemModel.QuantityFotmat = Number(itemModel.Quantity).toFixed(3);
                    itemModel.OriginalQuantity = item.Quantity || 1;
                    itemModel.OpenQty = item.OpenQty || 1;
                    itemModel.OriginalQuantityClose = item.Quantity - item.OpenQty;
                    itemModel.WhsCode = item.WhsCode;
                    itemModel.WhsName = item.Almacen;

                    itemModel.SalPackUn = item.SalPackUn || 1;
                    itemModel.PurPackUn = item.PurPackUn || 1;
                    itemModel.ItmsGrpCod = item.ItmsGrpCod;

                    itemModel.OcrCode = item.OcrCode;
                    itemModel.OcrName = "";
                    itemModel.OcrCode2 = item.OcrCode2;
                    itemModel.OcrName2 = "";
                    itemModel.OcrCode3 = item.OcrCode3;
                    itemModel.OcrName3 = "";
                    itemModel.OcrCode4 = item.OcrCode4;
                    itemModel.OcrName4 = "";
                    itemModel.OcrCode5 = item.OcrCode5;
                    itemModel.OcrName5 = "";

                    //#region GALLONS CONVERSION
                    itemModel.U_RS_UMED = item.U_RS_UMED || '';
                    itemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
                    itemModel.U_RS_PRECIOGL = Number(item.U_RS_PRECIOGL || 0);
                    if (development && !itemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
                        itemModel.U_RS_PRECIOGL = 100;
                    }
                    itemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
                    itemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
                    try {
                        if (newOrderModel?.Filler && Granel?.includes(Number(itemModel?.ItmsGrpCod))) {
                            enableSpinner(true);
                            const data = {
                                WhsCode: newOrderModel?.Filler,
                            };
                            const apiResponse = await apiClient.getFactorConversion(data);
                            enableSpinner(false);

                            if (apiResponse?.status === 1) {
                                itemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                            }
                        }
                    } catch (err) { }
                    itemModel.Gallons = item.U_RS_UMED === 'GLN';
                    //#endregion GALLONS CONVERSION

                    itemModel.U_RS_GRUPO = item.U_RS_GRUPO || '';

                    itemModel.UserFieldsItem.userFields1 = item.userFields1;
                    itemModel.UserFieldsItem.userFields2 = item.userFields2;
                    itemModel.UserFieldsItem.userFields3 = item.userFields3;
                    itemModel.UserFieldsItem.userFields4 = item.userFields4;
                    itemModel.UserFieldsItem.userFields5 = item.userFields5;
                    itemModel.UserFieldsItem.userFields6 = item.userFields6;
                    itemModel.UserFieldsItem.userFields7 = item.userFields7;
                    itemModel.UserFieldsItem.userFields8 = item.userFields8;
                    itemModel.UserFieldsItem.userFields9 = item.userFields9;
                    itemModel.UserFieldsItem.userFields10 = item.userFields10;
                    itemModel.UserFieldsItem.userFields11 = item.userFields11;
                    itemModel.UserFieldsItem.userFields12 = item.userFields12;
                    itemModel.UserFieldsItem.userFields13 = item.userFields13;
                    itemModel.UserFieldsItem.userFields14 = item.userFields14;
                    itemModel.UserFieldsItem.userFields15 = item.userFields15;
                    itemModel.UserFieldsItem.userFields16 = item.userFields16;
                    itemModel.UserFieldsItem.userFields17 = item.userFields17;
                    itemModel.UserFieldsItem.userFields18 = item.userFields18;
                    itemModel.UserFieldsItem.userFields19 = item.userFields19;
                    itemModel.UserFieldsItem.userFields20 = item.userFields20;
                    itemModel.UserFieldsItem.userFields21 = item.userFields21;
                    itemModel.UserFieldsItem.userFields22 = item.userFields22;
                    itemModel.UserFieldsItem.userFields23 = item.userFields23;
                    itemModel.UserFieldsItem.userFields24 = item.userFields24;
                    itemModel.UserFieldsItem.userFields25 = item.userFields25;
                    itemModel.UserFieldsItem.userFields26 = item.userFields26;
                    itemModel.UserFieldsItem.userFields27 = item.userFields27;
                    itemModel.UserFieldsItem.userFields28 = item.userFields28;
                    itemModel.UserFieldsItem.userFields29 = item.userFields29;
                    itemModel.UserFieldsItem.userFields30 = item.userFields30;

                    itemModel.NumPerMsr = item.NumPerMsr || 0;
                    itemModel.InvntItem = item.InvntItem || '';

                    let noList = parseInt(newOrderModel.GroupNum);
                    noList = (noList === -1 || noList === -2) ? noList + 1 : noList;
                    let price = item.itemPrice.filter((item) => item.PriceList === noList) || 0;

                    itemModel.Price = itemModel.Gallons && Granel?.includes(Number(itemModel?.ItmsGrpCod)) ? item.Price // Si es conversion a galones conservar precio
                        : price?.[0]?.Price ?? 0;
                    itemModel.HomePrice = itemModel.Gallons && Granel?.includes(Number(itemModel?.ItmsGrpCod)) ? item.Price // Si es conversion a galones conservar precio
                        : price?.[0]?.Price ?? 0;
                    itemModel.InvntryUom = item.InvntryUom;
                    itemModel.PricesList = item.itemPrice;
                    itemModel.AvgPrice = item.AvgPrice;
                    itemModel.ManBtchNum = item.ManBtchNum;

                    itemModel.stock = true;
                    itemModel.wareHouseStock = item.wareHouses;
                    itemModel.Filler = newOrderModel.Filler;
                    itemModel.FillerWhs = Array.isArray(item?.wareHouses) ? item.wareHouses.find(({ WhsCode }) => WhsCode === newOrderModel?.Filler) : {};
                    itemModel.FromLocationAssignment = Array.isArray(itemModel.FillerWhs?.Location) ? itemModel.FillerWhs.Location : [];
                    itemModel.ToWhsCode = newOrderModel.ToWhsCode;
                    itemModel.ToWhs = Array.isArray(item?.wareHouses) ? item.wareHouses.find(({ WhsCode }) => WhsCode === newOrderModel?.ToWhsCode) : {};

                    if (!itemModel?.FillerWhs?.OnHand) {
                        showAlert({ type: "warning", message: `El artículo ${item.ItemCode} ya no tiene existencia en el almacén de Origen` });
                        itemModel.stock = false;
                    }

                    //#region ########## BINS ##########
                    if (itemModel.FromLocationAssignment.length === 1) {
                        let location = itemModel.FromLocationAssignment[0];
                        if (Number(itemModel.Quantity) <= (Number(location.OnHandQty) || 0)) {
                            itemModel.TotalAsigned = Number(itemModel.Quantity).toFixed(3);
                            location.Quantity = Number(itemModel.Quantity).toFixed(3);
                            location.remainingQty = (Number(location.OnHandQty) - Number(itemModel.Quantity)).toFixed(3);
                        } else {
                            itemModel.TotalAsigned = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.remainingQty = "0.000";
                        }
                    } else if (itemModel.FromLocationAssignment.length && Number(itemModel.Quantity) === Number(item.FillerWhs?.OnHand || 0)) {
                        itemModel.TotalAsigned = Number(item.FillerWhs?.OnHand || 0).toFixed(3);

                        for (let location of itemModel.FromLocationAssignment) {
                            location.Quantity = (Number(location.OnHandQty) || 0).toFixed(3);
                            location.remainingQty = "0.000";
                        }
                    }

                    if (itemModel.ToWhs?.BinActivat === "Y") {
                        enableSpinner(true);
                        const ubication = await apiClient.getPriceKilo(item.ItemCode, newOrderModel.ToWhsCode);
                        enableSpinner(false);

                        itemModel.ToLocationAssignment = Array.isArray(ubication?.data?.results) ? ubication.data.results : [];
                        if (itemModel.ToLocationAssignment.length) {
                            itemModel.ToTotalAsigned = Number(itemModel.Quantity).toFixed(3);
                            itemModel.ToLocationAssignment[0].Quantity = Number(itemModel.Quantity).toFixed(3);
                        }
                    }
                    //#endregion
                    newOrderModel.Items.push(itemModel);
                }
            }
        }

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let userFields = new UserFields();
        json.allUserFields.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    const isInvoice = view === 'invoice';
                    const isCreditNote = view === 'creditNote';
                    const isDebitNote = view === 'debitNote';
                    if (isInvoice || isCreditNote || isDebitNote) {
                        const fieldsSelectList = ["U_BPP_MDTD", "U_BPP_MDSD"];
                        const aliasId = userfieldItem?.header?.AliasID || '';
                        item.fieldType = item.fieldType === 3 || fieldsSelectList.includes(aliasId) || fieldsSelectList.includes(`U_${aliasId}`) ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                    } else {
                        item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options?.length !== 0 ? 2 : 1;
                    }
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = setUserFieldValue(userFields, index, header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }

                    //#region SERIES Y CORRELATIVOS
                    if (isInvoice || isCreditNote || isDebitNote) { // Validación temporal
                        if (item.fieldId === 1) {//TIPO DE DOCUMENTO
                            let validOptions = [];
                            if (isInvoice) {
                                validOptions = [
                                    { value: '01', label: 'Factura' },
                                    { value: '03', label: 'Boleta' },
                                ]
                            } else if (isCreditNote) {
                                validOptions = [
                                    { value: '07', label: 'Nota de crédito' },
                                ]
                            } else if (isDebitNote) {
                                validOptions = [
                                    { value: '08', label: 'Nota de débito' }
                                ]
                            } else { // Guía
                                validOptions = [
                                    { value: '09', label: 'Guia' },
                                    { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                                ]
                            }
                            item.options = validOptions
                        }
                        if (item.fieldId === 22) {//CORRELATIVO DOCUMENTO
                            //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                        }
                        if (item.fieldId === 36) {//SERIE DOCUMENTO
                            let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                            let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                            let seriesPuerta = {}
                            let seriesPlanta = {}
                            try {
                                seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                            } catch (e) {
                                seriesPuerta = {};
                            }
                            try {
                                seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                            } catch (e) {
                                seriesPlanta = {};
                            }
                            const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                            seriesPuerta = parseSeries(seriesPuerta, noNeedDefault)
                            seriesPlanta = parseSeries(seriesPlanta, noNeedDefault)
                            const isZonal = Number(user?.Branch?.Type) === 1;
                            item.options = (isZonal
                                ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                                : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                            )?.filter((option, index, self) =>
                                index === self?.findIndex(x => x.value === option.value)
                            );
                        }
                    }
                    //#endregion SERIES Y CORRELATIVOS
                    userFields = newUserFields;
                }
                return null
            });
            return null
        });
        if (copyUserFields) {
            const newObject = Object.keys(header ?? {})
                .filter(key => key.startsWith('userFields'))
                .reduce((acc, key) => {
                    acc[key] = header[key];
                    return acc;
                }, {});

            newOrderModel.userFields =
                newObject &&
                    Object.keys(newObject).length > 0
                    ? newObject
                    : userFields;
        } else {
            newOrderModel.userFields = userFields;
        }

        //#region ATTACHMENT
        if (newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument) {
            if (documentsSelected?.length === 1) {
                newOrderModel.AtcEntry = header?.AtcEntry || null;
                newOrderModel.Attachment = header?.Attachment || [];
            }
        }
        //#endregion ATTACHMENT

        //#region CAMPOS EMPRESA
        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput';
        const isOWTR = view === 'transfers';
        const isOWTRoOWTQ = isOWTR || view === 'transfersRequest';

        if (isOIGNoOIGE || isOWTRoOWTQ) {
            newOrderModel.GroupNum = -1;
            newOrderModel.invFields = [];
            await processUserFields({
                fields: invFields,
                model: newOrderModel,
                targetProperty: "invFields",
                headerFields: isOWTRoOWTQ ? [] : [
                    'U_BPP_MDTS',
                    'U_RS_MOTIVOIS',
                    'U_RS_TIPOOPER',
                    'U_BPP_MDTD',
                    'U_BPP_MDSD',
                    'U_BPP_MDCD'
                ],
                dateFields: ["U_STR_FE_GRE_FechaTransporte"],
                isOWTRoOWTQ,
                isCopy: true,
                header
            });
        }

        if (isOWTRoOWTQ) {
            newOrderModel.transferFields = [];
            await processUserFields({
                fields: transferFields,
                model: newOrderModel,
                targetProperty: "transferFields",
                headerFields: [],
                dateFields: [],
                isOWTRoOWTQ,
                isCopy: true,
                header
            });
        }
        //#endregion

        await this.selectOfReference.disableDataTable();
        await $('#selectOfModal').modal('hide');
        this.refreshTotal(newOrderModel);
    }

    sendModel = async () => {
        const { newOrderModel, createDocument, view, showAlert, getUserFieldHeaderValue } = this.props;
        const priceListNum = (newOrderModel.GroupNum === -2 || newOrderModel.GroupNum === -1) ? newOrderModel.GroupNum + 1 : newOrderModel.GroupNum;

        for (const item of newOrderModel.Items) {
            if (!Number(item.Quantity || 0)) { return showAlert({ type: "warning", message: `${item.ItemCode}: La cantidad no puede esta vacia` }); }
            else if (Number(item.Quantity || 0) < 0) { return showAlert({ type: "warning", message: `${item.ItemCode}: La cantidad no puede ser negativa` }); }

            if ((newOrderModel.TransitType != 'PZ' && newOrderModel.TransitType != 'DZ' && newOrderModel.TransitType != 'DC') && item.FillerWhs?.BinActivat === "Y" && Number(item.TotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de origen` }); }
            if ((newOrderModel.TransitType != 'PZ' && newOrderModel.TransitType != 'DZ' && newOrderModel.TransitType != 'DC') && item.ToWhs?.BinActivat === "Y" && Number(item.ToTotalAsigned || 0) !== Number(item.Quantity)) { return showAlert({ type: "warning", message: `${item.ItemCode}: Asigne la cantidad total para las ubicaciones de destino` }); }

            // Validación de lista de precios para documentos de inventario
            if (!item.PricesList || item.PricesList.length === 0) continue;
            // if (!Number(item?.PricesList?.find(({ PriceList }) => PriceList === Number(priceListNum))?.Price ?? 0)) {
            //     return showAlert({ type: "warning", message: `${item.ItemCode}: No cuenta con un precio valido` });
            // }
        }

        if (newOrderModel.Transit.toString() !== "2") {
            if (newOrderModel.Filler === "" || newOrderModel.ToWhsCode === "") { return showAlert({ type: "warning", message: "Asegúrese de llenar de forma correcta los almacenes" }); }
            if (newOrderModel.ToWhsCode === newOrderModel.Filler && newOrderModel.Transit) { return showAlert({ type: "warning", message: "El almacén destino no puede ser el mismo que el almacén de origen" }); }
        }
        if (newOrderModel.Filler.toUpperCase() === "SAP-R1" || newOrderModel.Filler.toUpperCase() === "R1-R1") { return showAlert({ type: "warning", message: "No esta permitido usar el almacén de origen seleccionado para esta operación" }); }

        if (newOrderModel.Transit.toString() === "2") {
            if (newOrderModel.DocNumCEDIS === "") { return showAlert({ type: "warning", message: `Si seleccionas el tipo de traslado "Recuperar de CEDIS" debes de agregar un numero de documento` }); }
            if (newOrderModel.WarehouseCEDIS === "") { return showAlert({ type: "warning", message: `Si seleccionas el tipo de traslado "Recuperar de CEDIS" debes de agregar el almacen a donde se realizara la entrada de mercancia` }); }
        }

        // CODIGO SCOP
        const validSCOP = ['PR01', 'PR02'];
        const scopCodeIn = ['01', '02', '04', '18', '27'];//'07' no lleva scop, modificado nueva regla de noe
        const mustValidateSCOP =
            newOrderModel.Items.length > 0 &&
            newOrderModel.Items.some(
                line => validSCOP.includes((line.U_RS_NEGNR || '').trim())
            );

        let validMotivos = scopCodeIn.includes(newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado);
        const hasGranel =//no lleva scop, modificado nueva regla de noe
            newOrderModel.Items.length > 0 &&
            newOrderModel.Items.some(
                line => Granel.includes(line.ItmsGrpCod)
            );

        if (
            (mustValidateSCOP && newOrderModel.U_BPP_MDTS === 'TSE' && validMotivos && newOrderModel.userFields.userFields1 === '09' && hasGranel)
        ) {
            if (newOrderModel.U_FMB_SCOP_CODE === '') {
                showAlert({ type: "warning", message: "Debe de tener un codigo SCOP para crear el documento", timeOut: 5000 });
                return;
            }
            if (!newOrderModel.ValidSCOP) {
                showAlert({ type: "warning", message: "Debe de validar que el codigo SCOP es valido. (Enter en el campo o con el boton de lado derecho)", timeOut: 5000 });
                return;
            }
        }

        //#region Campos RAMO
        const isOWTRoOWTQ =
            view === 'transfers' ||
            view === 'transfersRequest' ||
            Number(newOrderModel?.ObjType) === 67 ||
            Number(newOrderModel?.ObjType) === 1250000001;

        if (isOWTRoOWTQ && !(await this.validateRAMOFields(newOrderModel, invFields, getUserFieldHeaderValue, isOWTRoOWTQ))) {
            return; // No continuar si fallaron las validaciones de RAMO
        }
        //#endregion Campos RAMO

        //#region GALLONS CONVERSION
        // if (newOrderModel?.DocType === 'I' && (newOrderModel?.isTransferDocument)) {
        if (newOrderModel?.DocType === 'I' && (false)) {
            let isGallonValid = true;
            let itemMessage = '';
            for (const item of newOrderModel.Items) {
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_CANTG || Number(item?.U_RS_CANTG) <= 0)) {
                    itemMessage = `La cantidad de galones del artículo ${item?.ItemCode || item?.ItemName} debe de ser mayor a 0`;
                    isGallonValid = false;
                    break;
                }
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_PRECIOGL || Number(item?.U_RS_PRECIOGL) <= 0)) {
                    itemMessage = `El artículo ${item?.ItemCode || item?.ItemName} no cuenta con un precio valido para la conversión a galones`;
                    isGallonValid = false;
                    break;
                }
            }
            if (!isGallonValid) {
                showAlert({ type: "warning", message: itemMessage, timeOut: 5000 });
                return
            };
        }
        //#endregion GALLONS CONVERSION


        if (!newOrderModel.SerieCode) { return showAlert({ type: "warning", message: "Selecciona una serie valida" }); }
        createDocument(newOrderModel);
    }
    changeBinLocationTr = (event) => {
        const { newOrderModel } = this.props;
        newOrderModel.U_FMB_BinLocationTr = event?.nativeEvent?.target?.value ?? null;
        this.refreshModel(newOrderModel);
    }
    searchLocations = async () => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        if ((newOrderModel?.Filler ?? '') == '') {
            showAlert({ type: 'warning', message: 'Selecciona almacén origen' });
            return;
        }
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        const search = {
            Sucursal: newOrderModel?.Filler ?? null,
            ToWhsCode: newOrderModel?.ToWhsCode ?? null,
            view
        }
        enableSpinner(true);
        let responseApi = await apiClient.getBinLocationBySucursal(search);
        enableSpinner(false);
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listBinLocations: responseApi?.data ?? [],
                showBinLocationsModal: true,
            }, () => {
                $("#sucursalLocationsModal").modal("show");
            })
        } else {
            showAlert({ type: 'warning', message: responseApi?.message ?? 'No se encontraron resultados' });
        }
    }
    changeCardType = (e) => {
        const { newOrderModel } = this.props
        this.clearBP();
        newOrderModel.CardType = e?.target?.value ?? null
        this.refreshModel(newOrderModel)

    }
    // HEADER DE CREACION DE TRASLADO
    renderDocumentTransfersHeader = () => {
        const { newOrderModel, action, view, prices } = this.props;
        const { editMode, _user } = this.state;
        // Al crear nuevo documento trae cero y no existe en el mapeo (Default -1 Ult precio de compra en SAP)
        newOrderModel.GroupNum = newOrderModel.GroupNum === 0 ? -1 : newOrderModel.GroupNum;
        const type = [{ key: 'C', value: 'Cliente' }, { key: 'S', value: 'Proveedor' }]
        const CardType = type.find(sel => sel.key === newOrderModel?.CardType ?? 'C')
        return (
            <div className="row">
                {/*Primera columna*/}
                <div className="col-12 col-md-6">
                    {/*CARDTYPE SELECTION*/}
                    {action == 1 &&
                        < div className="input-group mb-3">
                            < div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo</span>
                            </div>
                            <select className="form-control"
                                onChange={event => this.changeCardType(event)}
                                value={newOrderModel?.CardType ?? ""} >
                                {type?.map(sel => {
                                    return (
                                        <option value={sel?.key ?? null}>{sel?.value ?? ''}</option>
                                    )
                                })}

                            </select>
                        </div>
                    }
                    {/*No del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">{CardType?.value ?? '--'}</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtPartner"
                            style={{ backgroundColor: newOrderModel.partnerSelected ? "rgb(248,242,209)" : "transparent" }}
                            disabled={action === 2}
                            onKeyDown={({ key }) => { if (key === "Enter") { this.openPartner(); } }}
                            value={newOrderModel.CardCode || ""}
                            onChange={({ target: { value } }) => this.changeField("CardCode", value, 100)} />
                        {action == 1 &&
                            <button type="button" className="rounded-right btn btn-outline-warning" onClick={this.openPartner}> <i className="fas fa-user" /> </button>
                        }
                    </div>
                    {/*Nombre del cliente*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control input-sm"
                            id="txtName"
                            disabled
                            value={newOrderModel.CardName ? newOrderModel.CardName : ""}
                        />
                    </div>
                    {/*Persona de Contacto*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Contacto</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtContactPerson"
                            disabled
                            value={newOrderModel.CntctName ? newOrderModel.CntctName : ""}
                        />
                        {(action == 1 || (action == 2)) && (
                            <button
                                type="button"
                                className="rounded-right btn btn-outline-warning"
                                onClick={this.openPersonContact}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Address:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Dirección</span>
                        </div>
                        <input
                            readOnly
                            disabled
                            id="txtCustomerRefNo"
                            className="form-control"
                            value={newOrderModel.Address || ""} />
                    </div>

                    {((newOrderModel.OriginDocumentCreate === "transfers") && (action === 1)) &&
                        <>
                            {/* Almacén de transito */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">
                                        <span className="d-none d-xl-inline">Tipo de Traslado</span>
                                        <span className="d-inline d-xl-none">Tipo</span>
                                    </span>
                                </div>
                                <Select
                                    options={opcionesTipoTraslado}
                                    value={opcionesTipoTraslado.find(option => String(option.value) === String(newOrderModel?.Transit ?? '')) || null}
                                    onChange={(selectedOption) => this.changeAlmacenTransito(selectedOption)}
                                    isSearchable={true}
                                    isClearable={false}
                                    placeholder="Seleccionar"
                                    isDisabled={newOrderModel.OriginDocumentCreate === "transfersRequest"}
                                    styles={selectStyles}
                                />
                                {(newOrderModel?.Transit ?? '') === '1' &&
                                <Select
                                    options={opcionesTransitType}
                                    value={opcionesTransitType.find(option => String(option.value) === String(newOrderModel?.TransitType ?? '')) || null}
                                    onChange={(selectedOption) => this.changeTransitType(selectedOption)}
                                    isSearchable={true}
                                    isClearable={false}
                                    placeholder="Seleccionar"
                                    isDisabled={newOrderModel.OriginDocumentCreate === "transfersRequest"}
                                    styles={selectStyles}
                                />
                                }

                            </div>

                            {newOrderModel.OriginDocumentCreate === "transfers" &&
                                <>
                                    {/*NUMERO DE DOCUMENTO PARA REVERSA:*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">No. Doc Recuperar</span>
                                                <span className="d-inline d-xl-none">No. Doc</span>
                                            </span>
                                        </div>
                                        <input
                                            placeholder="Documentos pendientes CEDIS"
                                            className="form-control"
                                            disabled
                                            readOnly
                                            value={newOrderModel?.DocNumCEDIS ?? ""} />

                                        <button
                                            type="button"
                                            className={`rounded-right btn btn-outline-${((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? "secondary" : "warning"}`}
                                            disabled={(action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)}
                                            onClick={() => this.OpenTransfers()}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>

                                    </div>

                                    {/*>almacen de entrada CEDIS*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">Almacén de entrada</span>
                                                <span className="d-inline d-xl-none">Almacén</span>
                                            </span>
                                        </div>
                                        <input
                                            placeholder="Almacén Recepcion CEDIS"
                                            className="form-control"
                                            disabled
                                            readOnly
                                            value={newOrderModel.WarehouseCEDIS ?? ""} />

                                        <button
                                            type="button"
                                            className={`rounded-right btn btn-outline-${((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? "secondary" : "warning"}`}
                                            disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2))}
                                            onClick={() => this.SearchAlmacen(null, 117)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">Tipo de salida del documento</span>
                                                <span className="d-inline d-xl-none">Tipo salida</span>
                                            </span>
                                        </div>
                                        <Select
                                            options={opcionesTipoSalida}
                                            value={opcionesTipoSalida.find(option => String(option.value) === String(newOrderModel?.U_BPP_MDTS ?? '')) || null}
                                            onChange={(selectedOption) => this.change_U_BPP_MDTS(selectedOption)}
                                            isSearchable={true}
                                            isClearable={false}
                                            placeholder="-Selecciona-"
                                            isDisabled={action === 2 && !editMode}
                                            styles={selectStyles}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">Codigo Motivo Traslado</span>
                                                <span className="d-inline d-xl-none">Motivo</span>
                                            </span>
                                        </div>
                                        <Select
                                            options={opcionesMotivoTraslado}
                                            value={opcionesMotivoTraslado.find(option => String(option.value) === String(newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado ?? '')) || null}
                                            onChange={(selectedOption) => this.change_U_STR_FE_GRE_CodigoMotivoTraslado(selectedOption)}
                                            isSearchable={true}
                                            isClearable={false}
                                            placeholder="-Selecciona-"
                                            isDisabled={action === 2 && !editMode}
                                            styles={selectStyles}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Código SCOP</span>
                                        </div>
                                        <input
                                            type="text"
                                            maxLength="11"
                                            className="form-control"
                                            id="txtScop"
                                            disabled={action === 2 && !editMode}
                                            value={newOrderModel?.U_FMB_SCOP_CODE ?? ""}
                                            onChange={this.changeScopCode}
                                            onKeyPress={(eve) => {
                                                if (eve.key === 'Enter') {
                                                    this.props.scoopTools.checkScoop()
                                                }
                                            }}
                                        />
                                        {(action === 1 || (action === 2 && editMode)) && (
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={this.props.scoopTools.checkScoop}>
                                                <i className="fa fa-cloud" aria-hidden="true" />
                                            </button>
                                        )}
                                    </div>
                                </>
                            }
                        </>
                    }
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Serie</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled
                            value={newOrderModel.SerieName || ""}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                className="rounded-right btn btn-outline-warning"
                                onClick={this.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ""}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">F. Contabilización</span>
                                <span className="d-inline d-xl-none">F. Contab.</span>
                            </span>
                        </div>
                        <input
                            type="date"
                            id="txtPostingDate"
                            className="form-control"
                            disabled={action === 2}
                            value={newOrderModel.DocDate || ""}
                            onChange={({ target: { value } }) => this.changeField("DocDate", value)} />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            disabled={action == 2}
                            className=" form-control"
                            id="txtStatus"
                            value={newOrderModel.TaxDate || ""}
                            onChange={({ target: { value } }) => this.changeField("TaxDate", value)} />
                    </div>
                    {/*>almacen origen:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">De Almacén</span>
                                <span className="d-inline d-xl-none">Origen</span>
                            </span>
                        </div>
                        <input
                            placeholder="Almacén origen"
                            className="form-control"
                            disabled
                            readOnly
                            value={newOrderModel.Filler ? newOrderModel.Filler : ""} />
                        {(action === 1 /*&& ((!newOrderModel.Filler || newOrderModel.Filler === "") || (!newOrderModel.Transit || newOrderModel.Transit === "")) && (Number(newOrderModel?.Transit || 0) >= 1)*/) && // Solo mostrar si no se detecto el almacen de origen
                            <button type="button" className="rounded-right btn btn-outline-warning" onClick={() => this.SearchAlmacen(null, 2)}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                    </div>
                    {/*>almacen destino:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Almacén Destino</span>
                                <span className="d-inline d-xl-none">Destino</span>
                            </span>
                        </div>
                        <input
                            placeholder="Almacén destino"
                            className="form-control"
                            disabled
                            readOnly
                            value={newOrderModel.ToWhsCode ? newOrderModel.ToWhsCode : ""} />
                        {(action === 1 && (Number(newOrderModel?.Transit || 0) !== 2)) &&
                            <button type="button" className="rounded-right btn btn-outline-warning" onClick={() => this.SearchAlmacen(null, 3)}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                    </div>
                    {/* Lista de Precios: */}
                    {((view === "transfers" || view === "transfersRequest")) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Lista De Precios</span>
                                    <span className="d-inline d-xl-none">Precios</span>
                                </span>
                            </div>
                            <select className="form-control" disabled={(action === 2 && !editMode)}
                                onChange={action === 1 ? (event) => this.changeSelectedFieldDocument(event) : ""}
                                value={newOrderModel.GroupNum || -1} >

                                {prices.map(price => {
                                    return (
                                        <option value={price.ListNum}>{price.ListName}</option>
                                    )
                                })}
                                <option value={-1}>Último precio de compra</option>
                                <option value={-2}>Último precio determinado</option>
                            </select>
                        </div>)}
                    {/* TRANSPORTE */}
                    {(newOrderModel?.Transit ?? '') === '1' &&
                        < div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Transporte</span>
                            </div>
                            <input type=" text" className="form-control"
                                // disabled={(action === 2 && !editMode) ? true : false}
                                readOnly
                                // onChange={(event) => this.changeBinLocationTr(event)}
                                value={newOrderModel.U_FMB_BinLocationTr ? newOrderModel.U_FMB_BinLocationTr : ""}
                            />
                            <button type="button"
                                disabled={(action === 2 && !editMode) ? true : false}
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={this.searchLocations}>
                                <i className="fa fa-search" />
                            </button>
                        </div>
                    }
                </div>

            </div >
        );
    }

    renderDocumentTransfersBody = () => {
        const { newOrderModel, action, view } = this.props;
        let newOrderModelItems = Array.isArray(newOrderModel.Items) ? newOrderModel.Items : [];
        const isOWTR = (view === "transfers" && !newOrderModel?.newView) || newOrderModel?.newView === "transfers";
        const { invFLeft = [], invFRight = [] } = this.splitInHalf(newOrderModel?.invFields ?? [], false);
        const { OWTRFieldsLeft = [], OWTRFieldsRight = [] } = this.splitInHalf(newOrderModel?.transferFields ?? [], false, 'transferFields');
        const { editMode } = this.state;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001;
        return (
            <div className="mb-3">
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Contenido-T"
                            data-toggle="tab"
                            href="#dataContenido2"
                            role="tab"
                            aria-controls="dataContenido"
                            aria-selected="true">
                            Contenido
                        </a>
                        {Modules['InventoryFields'] && ((view === 'transfers' || view === 'transfersRequest')) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-InvFields"
                                data-toggle="tab"
                                href="#invFields"
                                role="tab"
                                aria-controls="invFields"
                                aria-selected="false">
                                Ramo
                            </a>
                        }
                        {newOrderModel?.isTransferDocument && <a
                            className={"nav-item nav-link font-weight-bold text-secondary"}
                            id="nav-profile-tab-Logistica"
                            data-toggle="tab"
                            href="#dataLogistica"
                            role="tab"
                            aria-controls="dataLogistica"
                            aria-selected="false">
                            Logística
                        </a>}
                        {Modules['LiquidationFields'] && (isOWTRoOWTQ) &&
                            <a
                                className={"nav-item nav-link font-weight-bold text-secondary"}
                                id="nav-profile-tab-LiquidationFields"
                                data-toggle="tab"
                                href="#liquidationFields"
                                role="tab"
                                aria-controls="liquidationFields"
                                aria-selected="false">
                                Liquidación
                            </a>
                        }
                    </div>
                </nav>

                <div className="tab-content border border-top-0 rounded-bottom p-3" style={{ textAlign: "left" }}>
                    <div
                        className="w-100 tab-pane fade show active"
                        id="dataContenido2"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 500, overflow: "auto" }}>
                        <table
                            id="dataTableDocuments"
                            className="table response"
                            style={{ width: "100%", marginBottom: 40, marginRight: -2000 }}>
                            <thead className="table-header-yellow">
                                <tr className="text-center" style={{ backgroundColor: "#d2ab24", whiteSpace: "nowrap" }}>
                                    <td className="sticky-header sticky-column" style={{ backgroundColor: "#d2ab24" }}> Artículo </td>
                                    <td className="sticky-header" style={{ maxWidth: 200 }}> Descripción </td>
                                    {/* <td className="sticky-header" style={{ minWidth: 115 }}> Almacén </td> */}
                                    <td className="sticky-header" style={{ minWidth: 80 }}> Cant. Almacén Or </td>
                                    <td className="sticky-header" style={{ minWidth: 80 }}> Cant. Almacén De </td>
                                    {isOWTRoOWTQ && Modules.CostCenter && <>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CANAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SEDES
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            SUCURSAL
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            NEGOCIO
                                        </td>
                                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                                            CECO
                                        </td>
                                    </>}
                                    {newOrderModel.isTransferDocument &&
                                        <>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                UND Med.
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                                                Cant. Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                Precio Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                                                Total Galones
                                            </td>
                                            <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                                                Densidad
                                            </td>
                                        </>
                                    }
                                    <td className="sticky-header" style={{ maxWidth: 80 }}> Cantidad </td>
                                    {(view === "transfers") && (
                                        <>
                                            <td className="sticky-header"> DE ALMACÉN </td>
                                            <td className="sticky-header"> DE UBICACIONES </td>
                                            <td className="sticky-header"> ALMACÉN DESTINO </td>
                                            <td className="sticky-header"> A UBICACIONES </td>
                                            <td className="sticky-header"> PRIMERA UBICACIÓN DE DESTINO </td>
                                            <td className="sticky-header" style={{ minWidth: 80 }}> Peso </td>
                                            <td className="sticky-header" style={{ minWidth: 80 }}> Peso Total </td>
                                        </>
                                    )}
                                    <td className="sticky-header"> Precio </td>
                                    <td className="sticky-header" style={{ width: 130 }}> Costo artículo </td>
                                    <td className="sticky-header" style={{ width: 130 }}> Código UMI </td>
                                    <td className="sticky-header" style={{ width: 130 }}> Cesion uso </td>
                                    {/* CAMPOS DE USUARIO LINE */}
                                    {json.allItemsUserFields.map((field, index) => {
                                        if (field.enabled) {
                                            return (
                                                <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                                    {field.name}
                                                </td>
                                            );
                                        }
                                    })}
                                    <td className="sticky-header sticky-columns" style={{ backgroundColor: "#d2ab24" }} />
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModelItems.map((item, index) =>
                                    <tr className={!item.stock ? "row-sin-stock" : ""} style={{ color: item.stock ? "black" : "red" }}>
                                        <td className="sticky-column" style={{ backgroundColor: "#FFF" }}>
                                            {item.ItemCode}
                                        </td>
                                        {/*Artículos*/}
                                        <td
                                            className="overflow-visible"
                                            style={{ textAlign: "center", maxWidth: 200 }}>
                                            {item.ItemName}
                                        </td>
                                        {/*Almacén*/}
                                        {/* <td style={{ textAlign: "center" }}>
                                            <button
                                                type="button"
                                                className={`mx-auto btn btn-outline-${(action === 2 && !editMode) ? "secondary" : "warning"}`}
                                                disabled={(action === 2 && !editMode)}
                                                onClick={() => this.SearchAlmacen(index, 5, item.ItemCode)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </td> */}
                                        {/*Cantidad en Almacén Origen*/}
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control text-right"
                                                disabled
                                                readOnly
                                                value={FORMAT_NUMBER.new(item.FillerWhs?.OnHand || 0, "", 3)} />
                                        </td>
                                        {/*Cantidad en Almacén Destino*/}
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control text-right"
                                                disabled
                                                readOnly
                                                value={FORMAT_NUMBER.new(item.ToWhs?.OnHand || 0, "", 3)} />
                                        </td>

                                        {isOWTRoOWTQ && Modules.CostCenter && <>
                                            {/* CANAL */}
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={item.OcrCode || ""} />

                                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension1) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openCentroCoste(index, 1)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            {/* SEDES */}
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={item.OcrCode2 || ""} />

                                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension2) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openCentroCoste(index, 2)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            {/* SUCURSAL */}
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={item.OcrCode3 || ""} />

                                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension3) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openCentroCoste(index, 3)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            {/* NEGOCIO */}
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={item.OcrCode4 || ""} />

                                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension4) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openCentroCoste(index, 4)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            {/* CECO */}
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={item.OcrCode5 || ""} />

                                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension5) && (
                                                        <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    color: '#EABF28',
                                                                    paddingTop: 2,
                                                                    paddingBottom: 2,
                                                                    border: "1px solid #ced4da"
                                                                }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.openCentroCoste(index, 5)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </>}

                                        {newOrderModel.isTransferDocument &&
                                            <>
                                                {/* UND Med. */}
                                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                    this.emptyField()
                                                    :
                                                    <>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <select className="form-control"
                                                                disabled={Number(action) !== 1}
                                                                onChange={event =>
                                                                    (Number(action) === 1) &&
                                                                    this.changeUserUM(index, event)
                                                                }
                                                                value={item.U_RS_UMED || ''} >
                                                                <option value={''}> {'Seleccionar'}</option>
                                                                <option value={'KGM'}> {'Kilogramos'}</option>
                                                                <option value={'GLN'}> {'Galones'}</option>
                                                            </select>
                                                        </td>
                                                    </>
                                                }
                                                {/* Cant. Galones */}
                                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                    this.emptyField()
                                                    :
                                                    <>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="text"
                                                                id={`CANTG-${index}`}
                                                                className="form-control btn-outline-secondary"
                                                                disabled={(item.U_RS_UMED !== 'GLN' || (Number(action) !== 1))}
                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                value={item.U_RS_CANTG || ''}
                                                                onChange={event =>
                                                                    item.U_RS_UMED === 'GLN' &&
                                                                    Number(action) === 1 &&
                                                                    this.changeGalonesCant(index, event)
                                                                }
                                                                onBlur={event =>
                                                                    item.U_RS_UMED === 'GLN' &&
                                                                    Number(action) === 1 &&
                                                                    this.changeQuantityBlur(index, event, 'U_RS_CANTG')
                                                                }
                                                            />
                                                        </td>
                                                    </>
                                                }
                                                {/* Precio Galones */}
                                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                    this.emptyField()
                                                    :
                                                    <>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="text"
                                                                id={`PRECIOGL-${index}`}
                                                                className="form-control btn-outline-secondary"
                                                                disabled={true} readOnly={true}
                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                value={item.U_RS_PRECIOGL || ''}
                                                            />
                                                        </td>
                                                    </>
                                                }
                                                {/* Total Galones */}
                                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                    this.emptyField()
                                                    :
                                                    <>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="text"
                                                                id={`TOTALGL-${index}`}
                                                                className="form-control btn-outline-secondary"
                                                                disabled={true} readOnly={true}
                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                value={item.U_RS_TOTALGL || ''}
                                                            />
                                                        </td>
                                                    </>
                                                }
                                                {/* Densidad */}
                                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                                    this.emptyField()
                                                    :
                                                    <>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="text"
                                                                id={`DENS-${index}`}
                                                                className="form-control btn-outline-secondary"
                                                                disabled={true} readOnly={true}
                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                value={item.U_RS_DENS || ''}
                                                            />
                                                        </td>
                                                    </>
                                                }
                                            </>
                                        }

                                        {/* CANTIDAD */}
                                        <td className="text-right">
                                            {newOrderModel?.CEDIS_Reception ? FORMAT_NUMBER.new(item.Quantity, "", 3) :
                                                <input
                                                    className="form-control text-right"
                                                    style={{ width: 100 }}
                                                    disabled={newOrderModel?.isTransferDocument && item.Gallons ? true : newOrderModel.U_FMB_EditTraslado === "Y" ? false : action == 2}
                                                    value={item.QuantityFotmat || ""}
                                                    onChange={({ target: { value } }) => this.changeQuantityItem(index, value)}
                                                    onBlur={() => this.validateQty(index, item.Quantity)} />
                                            }
                                        </td>

                                        {(view === "transfers") && (
                                            <>
                                                <td className="text-center">{item.Filler}</td>
                                                <td>
                                                    {item.FillerWhs?.BinActivat !== "Y" ? <></> :
                                                        <div className="input-group" style={{ width: 150 }}>
                                                            <button
                                                                type="button"
                                                                className="rounded-left btn btn-outline-warning"
                                                                onClick={() => this.showLocationAssignment(item.LineNum, 1)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                            <input
                                                                className={`form-control text-right ${Number(item.Quantity) !== Number(item.TotalAsigned) ? "text-danger" : ""}`}
                                                                disabled
                                                                readOnly
                                                                value={FORMAT_NUMBER.new(item.TotalAsigned, "", 3)} />
                                                        </div>
                                                    }
                                                </td>
                                                <td style={{ textAlign: "center" }}>{item.ToWhsCode}</td>
                                                <td >
                                                    {item.ToWhs?.BinActivat !== "Y" ? <></> :
                                                        <div className="input-group" style={{ width: 150 }}>
                                                            <button
                                                                type="button"
                                                                className="rounded-left btn btn-outline-warning"
                                                                onClick={() => this.showLocationAssignment(item.LineNum, 2)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                            <input
                                                                className={`form-control text-right ${Number(item.Quantity) !== Number(item.ToTotalAsigned) ? "text-danger" : ""}`}
                                                                disabled
                                                                readOnly
                                                                value={FORMAT_NUMBER.new(item.ToTotalAsigned, "", 3)} />
                                                        </div>
                                                    }
                                                </td>
                                                <td style={{ textAlign: "left" }}>
                                                    {!Array.isArray(item.ToLocationAssignment) || !item.ToLocationAssignment?.length ? <></> :
                                                        <div className="input-group" style={{ width: 200 }}>
                                                            <button
                                                                type="button"
                                                                className="rounded-left btn btn-outline-warning"
                                                                onClick={() => this.showLocationAssignment(item.LineNum, 2)}>
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                            <input
                                                                className={`form-control text-right ${Number(item.Quantity) !== Number(item.ToTotalAsigned) ? "text-danger" : ""}`}
                                                                disabled
                                                                readOnly
                                                                value={item.ToLocationAssignment[0].BinCode || ""} />
                                                        </div>
                                                    }
                                                </td>
                                                <td>{/*Peso*/}
                                                    <input
                                                        type="text"
                                                        className="form-control text-right"
                                                        style={{ width: 100 }}
                                                        disabled
                                                        readOnly
                                                        value={FORMAT_NUMBER.new(item.Weight || 0, "", 3)} />
                                                </td>
                                                <td>{/*Peso total*/}
                                                    <input
                                                        type="text"
                                                        className="form-control text-right"
                                                        style={{ width: 100 }}
                                                        disabled
                                                        readOnly
                                                        value={FORMAT_NUMBER.new(Number(item.Weight || 0) * Number(item.Quantity || 0), "", 3)} />
                                                </td>
                                            </>
                                        )}

                                        {/*Precio*/}
                                        <td>
                                            <div className="input-group" style={{ width: 150 }}>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> {CURRENCY} </span>
                                                </div>
                                                <input
                                                    className="form-control text-right"
                                                    disabled
                                                    readOnly
                                                    value={FORMAT_NUMBER.new(item.Price || 0)} />
                                            </div>
                                        </td>
                                        {/* Costo del artículo */}
                                        {(view === "transfersRequest" || view === "transfers") && (
                                            <td style={{ textAlign: "right" }}>
                                                {CURRENCY + " " + FORMAT_NUMBER.new(item.AvgPrice)}
                                                {/* {newOrderModel.DocCur + " " + FORMAT_NUMBER.new(item.AvgPrice)} */}
                                            </td>)
                                        }
                                        {/*Código UMI*/}
                                        {(view === "transfersRequest" || view === "transfers") && (
                                            <td style={{ textAlign: "center" }}>
                                                {item.InvntryUom || ""}
                                            </td>)
                                        }
                                        {/*CESION USO*/}
                                        {(view === "transfersRequest" || view === "transfers") && (
                                            <td style={{ textAlign: "center" }}>
                                                {item.MovimientoDiario || "0"}
                                            </td>)
                                        }
                                        {/*Centros de costos*/}
                                        {/* <td>
                                            {item.OcrCode}
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#EABF28",
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openCentroCoste(index, 1)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            {item.OcrCode2}
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#EABF28",
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openCentroCoste(index, 2)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            {item.OcrCode3}
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#EABF28",
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openCentroCoste(index, 3)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            {item.OcrCode4}
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#EABF28",
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openCentroCoste(index, 4)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            )}
                                        </td> */}
                                        {/* CAMPOS DE USUARIO LINE */}
                                        {json.allItemsUserFields.map((field, indexField) => {

                                            if (field.enabled) {
                                                return (
                                                    <td style={{ textAlign: 'right' }}>
                                                        {(
                                                            Number(field.fieldType) === 1 ?
                                                                <input
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                        paddingTop: 1,
                                                                        paddingBottom: 2,
                                                                        minWidth: 100,
                                                                        textAlign: "center",
                                                                    }}
                                                                    className="form-control"
                                                                    type="text"
                                                                    id={'inputUserField' + 1}
                                                                    disabled={(Number(action) === 2 && !editMode) || (field.fieldId === isCilindrosVaciosDevueltos && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                                    value={field.name == 'Precio x kilo' ? (this.returnValueItem(field.IdValue, index) || item.PrecioKilo) : this.returnValueItem(field.IdValue, index)}
                                                                    onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}

                                                                /> :
                                                                <select
                                                                    className="form-control"
                                                                    id={'selectUserField' + 1}
                                                                    disabled={((Number(action) === 2 && !editMode) || (field.fieldId === isTipoConvenio && Number(newOrderModel.Items[index].UserFieldsItem.userFields1 || 0) !== 2)) || ((field.fieldId === isEntregaCilindro || field.fieldId === isTipoConvenio) && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                                    value={this.returnValueItem(field.IdValue, index)}
                                                                    onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                                >
                                                                    {field.options.map((option) => {
                                                                        if (option.FldValue != null) {
                                                                            return (
                                                                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }

                                                                    })}
                                                                </select>
                                                        )}
                                                    </td>
                                                );
                                            } else {
                                                return (<></>)
                                            }
                                        })}
                                        {/*Eliminar*/}
                                        <td className="sticky-columns" style={{ backgroundColor: "#FFF" }}>
                                            {action == 1 && !newOrderModel?.CEDIS_Reception && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() => this.deleteItem(index)}>
                                                    <i className="fas fa-trash-alt" />
                                                </button>
                                            )}
                                        </td>
                                        {" "}

                                    </tr>
                                )}
                                {!newOrderModel?.CEDIS_Reception &&
                                    <tr>
                                        <td className="sticky-column" colSpan={3}>
                                            {action == 1 && (
                                                <div className="input-group" style={{ maxWidth: 250 }}>
                                                    <input
                                                        placeholder="Artículo"
                                                        className="form-control"
                                                        value={newOrderModel.searchItem || ""}
                                                        onChange={({ target: { value } }) => this.changeField("searchItem", value, 100)}
                                                        onKeyDown={({ key }) => { if (key === "Enter") { this.openItems(); } }} />
                                                    <button
                                                        type="button"
                                                        className="rounded-right btn btn-outline-success"
                                                        onClick={() => this.openItems()}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                    </button>
                                                </div>

                                            )}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {/* INVENTORY FIELDS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="w-100 tab-pane fade"
                        id="invFields"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-InvFields">
                        <div className="row">
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFLeft, newOrderModel, action, editMode)}</div>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(invFRight, newOrderModel, action, editMode)}</div>
                        </div>
                    </div>
                    {/* Logística */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="tab-pane fade"
                        id="dataLogistica"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Logistica">
                        <div className="row" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Destino</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtShipToCode"
                                        disabled="true"
                                        value={newOrderModel.ShipToCode ? newOrderModel.ShipToCode : ''}
                                    />
                                    {Number(action) === 1 && (
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => this.openAddresses(1)}>
                                            <i className="fas fa-list" />
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/*Segunda columna*/}
                        </div>
                    </div>
                    {/* LIQUIDATION FIELDS */}
                    <div
                        style={{ paddingTop: 5 }}
                        className="w-100 tab-pane fade"
                        id="liquidationFields"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-LiquidationFields">
                        <div className="row">
                            <div className="col-12 col-md-6">{this.renderSpecificFields(OWTRFieldsLeft, newOrderModel, action, editMode)}</div>
                            <div className="col-12 col-md-6">{this.renderSpecificFields(OWTRFieldsRight, newOrderModel, action, editMode)}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //#region Campos RAMO
    getFieldDataRAMO = async (field, newOrderModel, invFields) => {
        const { getUserFieldHeaderValue } = this.props;
        const isActive = invFields?.some(f => f.Field === field && f.active === true);

        const headerData = await getUserFieldHeaderValue(field, newOrderModel, true);

        return {
            field,
            active: isActive,
            value: newOrderModel?.[field] ?? '',
            Descr: headerData?.headerMatch?.header?.Descr || field
        };
    };

    isEmptyValueRAMO = (val) => {
        return !val || val === '' || val === '-' || val === '- --' || val == null;
    };

    validateRAMOFields = async (newOrderModel, invFields, getUserFieldHeaderValue, isOWTRoOWTQ = true) => {
        //#region Revisar Serie de documento
        if (isOWTRoOWTQ) { // En Solicitud de traslado y en traslados de momento vienen de campos del json
            const U_BPP_MDSD = await getUserFieldHeaderValue('U_BPP_MDSD', newOrderModel, false);

            const serie = (U_BPP_MDSD ?? '')?.toString()?.toUpperCase();

            if (!serie?.startsWith('T')) {
                return true; // No hubo error
            }
        }
        //#region Revisar Serie de documento

        const { showAlert } = this.props;
        const fieldsToEvaluate = [
            'U_STR_FE_GRE_ModalidadTransporte',
            'U_STR_FE_GRE_CodigoMotivoTraslado',
            'U_STR_FE_GRE_DescriMotivoTraslado',
            'U_STR_FE_GRE_FechaTransporte',
            'U_STR_FE_GRE_TipoDocTransporte',
            'U_STR_FE_GRE_NumDocTransporte',
            'U_STR_FE_GRE_RazonSocialTransporte',
            'U_STR_FE_GRE_NumeroMTC',
            'U_STR_FE_GRE_UnidadMedida',
            'U_STR_FE_GRE_TipoDocConductor',
            'U_STR_FE_GRE_NumeroDocConductor',
            'U_STR_FE_GRE_NombreConductor',
            'U_STR_FE_GRE_ApellidoConductor',
            'U_STR_FE_GRE_LicenciaConductor',
            'U_STR_FE_GRE_PlacaVehiculo',
            'U_RML_GRE_UBILLE',
            'U_RML_GRE_UBIPAR',
            'U_RML_GRE_DNI',
            'U_RML_GRE_NOM',
            'U_RML_GRE_LICENCIA',
            'U_RML_GRE_VEHICULO',
            'U_RML_GRE_CODSUCURSAL',
            'U_RML_GRE_DIRLLE',
            'U_RML_GRE_DIRPAR',
        ];

        const fieldMap = {};

        for (const field of fieldsToEvaluate) {
            fieldMap[field] = await this.getFieldDataRAMO(field, newOrderModel, invFields); // Obtener descripción y valor
        }

        const CODIGO = fieldMap['U_STR_FE_GRE_CodigoMotivoTraslado'];
        const DESCRIPCION = fieldMap['U_STR_FE_GRE_DescriMotivoTraslado'];
        const UBILLE = fieldMap['U_RML_GRE_UBILLE'];
        const UBIPAR = fieldMap['U_RML_GRE_UBIPAR'];
        const SUCURSAL = fieldMap['U_RML_GRE_CODSUCURSAL'];
        const FECHA = fieldMap['U_STR_FE_GRE_FechaTransporte'];
        const UNIDAD = fieldMap['U_STR_FE_GRE_UnidadMedida'];
        const MODALIDAD = fieldMap['U_STR_FE_GRE_ModalidadTransporte'];

        const TIPO_DOC_TRANSP = fieldMap['U_STR_FE_GRE_TipoDocTransporte'];
        const NUM_DOC_TRANSP = fieldMap['U_STR_FE_GRE_NumDocTransporte'];
        const RAZON_SOCIAL = fieldMap['U_STR_FE_GRE_RazonSocialTransporte'];
        const MTC = fieldMap['U_STR_FE_GRE_NumeroMTC'];

        const DNI = fieldMap['U_RML_GRE_DNI'];
        const NOM = fieldMap['U_RML_GRE_NOM'];
        const LIC = fieldMap['U_RML_GRE_LICENCIA'];
        const VEH = fieldMap['U_RML_GRE_VEHICULO'];

        const TIPO_DOC_COND = fieldMap['U_STR_FE_GRE_TipoDocConductor'];
        const NUM_DOC_COND = fieldMap['U_STR_FE_GRE_NumeroDocConductor'];
        const NOM_COND = fieldMap['U_STR_FE_GRE_NombreConductor'];
        const APE_COND = fieldMap['U_STR_FE_GRE_ApellidoConductor'];
        const LIC_COND = fieldMap['U_STR_FE_GRE_LicenciaConductor'];
        const PLACA = fieldMap['U_STR_FE_GRE_PlacaVehiculo'];

        const DIRLLE = fieldMap['U_RML_GRE_DIRLLE'];
        const DIRPAR = fieldMap['U_RML_GRE_DIRPAR'];

        const err = (field, labelFallback) => {
            showAlert({
                type: 'warning',
                message: `Es necesario un valor para el campo "${field?.header || labelFallback}"`,
                timeOut: 8000
            });
            return false; // Hubo error
        };

        if (
            CODIGO?.active && CODIGO?.value === '02' &&
            UBILLE?.active && !this.isEmptyValueRAMO(UBILLE?.value) &&
            SUCURSAL?.active && this.isEmptyValueRAMO(SUCURSAL?.value)
        ) return err(SUCURSAL, 'Código Sucursal');

        if (
            CODIGO?.active && CODIGO?.value !== '02' &&
            UBIPAR?.active && !this.isEmptyValueRAMO(UBIPAR?.value) &&
            SUCURSAL?.active && this.isEmptyValueRAMO(SUCURSAL?.value)
        ) return err(SUCURSAL, 'Código Sucursal');

        if (CODIGO?.active && this.isEmptyValueRAMO(CODIGO?.value))
            return err(CODIGO, 'Código Motivo Traslado');

        if (DESCRIPCION?.active && this.isEmptyValueRAMO(DESCRIPCION?.value))
            return err(DESCRIPCION, 'Descripción Motivo Traslado');

        if (FECHA?.active) {
            if (this.isEmptyValueRAMO(FECHA?.value))
                return err(FECHA, 'Fecha entrega Transportista');

            if (!moment(FECHA?.value, moment.ISO_8601, true).isValid()) {
                showAlert({
                    type: 'warning',
                    message: `La fecha ingresada en "${FECHA?.header}" no es válida`,
                    timeOut: 8000
                });
                return false;
            }
        }

        if (UNIDAD?.active && this.isEmptyValueRAMO(UNIDAD?.value))
            return err(UNIDAD, 'Unidad Medida');

        //#region Modalidades
        if (MODALIDAD?.active && this.isEmptyValueRAMO(MODALIDAD?.value))
            return err(MODALIDAD, 'Modalidad Transporte');

        if (MODALIDAD?.active && MODALIDAD?.value === '01') {
            if (TIPO_DOC_TRANSP?.active && this.isEmptyValueRAMO(TIPO_DOC_TRANSP?.value)) return err(TIPO_DOC_TRANSP, 'Tipo Doc Transportista');
            if (NUM_DOC_TRANSP?.active && this.isEmptyValueRAMO(NUM_DOC_TRANSP?.value)) return err(NUM_DOC_TRANSP, 'Num Doc Transportista');
            if (RAZON_SOCIAL?.active && this.isEmptyValueRAMO(RAZON_SOCIAL?.value)) return err(RAZON_SOCIAL, 'Razón Social');
            if (MTC?.active && this.isEmptyValueRAMO(MTC?.value)) return err(MTC, 'Número MTC');
            if (DNI?.active && this.isEmptyValueRAMO(DNI?.value)) return err(DNI, 'DNI transportista');
            if (NOM?.active && this.isEmptyValueRAMO(NOM?.value)) return err(NOM, 'Nombres transportista');
            if (LIC?.active && this.isEmptyValueRAMO(LIC?.value)) return err(LIC, 'Licencia transportista');
            if (VEH?.active && this.isEmptyValueRAMO(VEH?.value)) return err(VEH, 'Vehículo transportista');
        }

        if (MODALIDAD?.active && MODALIDAD?.value === '02') {
            if (TIPO_DOC_COND?.active && this.isEmptyValueRAMO(TIPO_DOC_COND?.value)) return err(TIPO_DOC_COND, 'Tipo Doc Conductor');
            if (NUM_DOC_COND?.active && this.isEmptyValueRAMO(NUM_DOC_COND?.value)) return err(NUM_DOC_COND, 'Número Doc Conductor');
            if (NOM_COND?.active && this.isEmptyValueRAMO(NOM_COND?.value)) return err(NOM_COND, 'Nombre Conductor');
            if (APE_COND?.active && this.isEmptyValueRAMO(APE_COND?.value)) return err(APE_COND, 'Apellido Conductor');
            if (LIC_COND?.active && this.isEmptyValueRAMO(LIC_COND?.value)) return err(LIC_COND, 'Licencia Conductor');
            if (PLACA?.active && this.isEmptyValueRAMO(PLACA?.value)) return err(PLACA, 'Placa Vehículo');
        }
        //#endregion Modalidades

        //#region Código Motivo Traslado
        if (CODIGO?.active && ['01', '13', '14', '18']?.includes(CODIGO?.value)) {
            if ((UBILLE?.active && !this.isEmptyValueRAMO(UBILLE?.value)) && (DIRLLE?.active && this.isEmptyValueRAMO(DIRLLE?.value)))
                return err(DIRLLE, 'Dirección Llegada');

            if ((DIRLLE?.active && !this.isEmptyValueRAMO(DIRLLE?.value)) && (UBILLE?.active && this.isEmptyValueRAMO(UBILLE?.value)))
                return err(UBILLE, 'Ubigeo Llegada');
        }

        if (CODIGO?.active && ['02']?.includes(CODIGO?.value)) {
            if ((UBIPAR?.active && !this.isEmptyValueRAMO(UBIPAR?.value)) && (DIRPAR?.active && this.isEmptyValueRAMO(DIRPAR?.value)))
                return err(DIRPAR, 'Dirección Partida');

            if ((DIRPAR?.active && !this.isEmptyValueRAMO(DIRPAR?.value)) && (UBIPAR?.active && this.isEmptyValueRAMO(UBIPAR?.value)))
                return err(UBIPAR, 'Ubigeo Partida');
        }
        //#endregion Código Motivo Traslado 

        return true; // No hubo error
    };
    //#region Campos RAMO

    changeHeaderField = async (key, value, maxLength = null, isNumber = false) => {
        if (!key) {
            return;
        }
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        const copyModel = JSON.parse(JSON.stringify(newOrderModel))
        let newValue = value ?? '';
        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(copyModel?.ObjType) === 59 || Number(copyModel?.ObjType) === 60;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(copyModel?.ObjType) === 67 || Number(copyModel?.ObjType) === 1250000001;

        if (isNumber) {
            newValue = newValue?.replace(/[^0-9.]/g, '');
            const parts = newValue?.split('.');
            if (parts?.length > 2) {
                newValue = parts[0] + '.' + parts?.slice(1)?.join('');
            }
        }

        if (maxLength) {
            newValue = newValue?.slice(0, maxLength);
        }
        copyModel[key] = newValue;
        await this.refreshModel(copyModel);
        //#region RETENCIONES
        if (key === 'U_RS_IMP' && (copyModel.RetencionVista || copyModel?.newView === 'PurchaseOrder')) {
            await this.refreshTotal(copyModel);
        }
        //#endregion RETENCIONES
        if ((view === 'transfersEntry' || view === 'transfersOutput') && key === 'U_RS_TIPOOPER' && copyModel?.DocType === 'I' && copyModel?.Items?.length) {
            for (const item of copyModel?.Items) {
                const aliasToFind = "U_tipoOpT12";
                const headers = copyModel?.userFieldsBody || [];
                const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
                const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

                if (bodyMatch) {
                    const fieldId = bodyMatch?.header?.FieldID;
                    const options = bodyMatch?.options || [];
                    const allFields = json?.allItemsUserFields || [];
                    const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                    if (foundIndex !== -1) {
                        const fieldNumber = foundIndex + 1;
                        const U_tipoOpT12 = options?.find(option => value ? option?.FldValue?.toUpperCase() === value : option?.FldValue?.toUpperCase() === value || option?.FldValue?.toUpperCase() === null)?.FldValue || '';
                        item.UserFieldsItem[`userFields${fieldNumber}`] = U_tipoOpT12; // Asignar mismo que el de cabecera
                    }
                }
            }
            await this.refreshModel(copyModel);
        }

        //#region Valores dependientes
        if (!isNumber && (isOIGNoOIGE || isOWTRoOWTQ)) {
            const Field = key;
            const linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
            if (linkedFields?.length) {
                if (value) {
                    enableSpinner(true);
                    let data = {
                        Field,
                        param1: value
                    };
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);

                    if (res?.status) {
                        const row = res?.data ?? {};

                        for (const lf of linkedFields) { // Asignar valores a campos dependientes
                            const targetField = lf.Field;

                            if (row.hasOwnProperty(targetField)) {
                                copyModel[targetField] = row[targetField];
                            } else {
                                copyModel[targetField] = '';
                            }
                        }

                    } else { // Limpiar dependientes
                        showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo` });
                        for (const lf of linkedFields) {
                            copyModel[lf.Field] = '';
                        }
                    }

                } else { // Limpiar dependientes
                    for (const lf of linkedFields) {
                        copyModel[lf.Field] = '';
                    }
                }
            }
            await this.refreshModel(copyModel);
        }
        if (isOWTRoOWTQ) {
            if (key === 'U_RML_TIPOS13') {
                const CodigoMotivoTraslado = copyModel.U_STR_FE_GRE_CodigoMotivoTraslado;
                if (CodigoMotivoTraslado === '13') {
                    const tipos13Field = copyModel?.invFields?.find(field => field?.Field === key);
                    let tipos13Desc = tipos13Field?.options?.find(option => option?.FldValue === value)?.Descr || '';
                    enableSpinner(true);
                    let data = {
                        Field: 'U_STR_FE_GRE_CodigoMotivoTraslado',
                        param1: CodigoMotivoTraslado
                    };
                    let res = await apiClient.getFormattedQueriesByCUFD(data);
                    enableSpinner(false);
                    const row = res?.data ?? {};
                    copyModel.U_STR_FE_GRE_DescriMotivoTraslado = tipos13Desc ? `${row?.U_STR_FE_GRE_DescriMotivoTraslado || ''}: ${tipos13Desc}` : row?.U_STR_FE_GRE_DescriMotivoTraslado || '';
                    await this.refreshModel(copyModel);
                }
            }
        }
        //#endregion Valores dependientes
    };

    changeBlurHeaderField = async (key, value, toFixedValue = null) => {
        const { newOrderModel } = this.props;
        const copyModel = JSON.parse(JSON.stringify(newOrderModel))
        if (toFixedValue || toFixedValue === 0) {
            value = !value || value === '.' ? 0 : value;
            copyModel[key] = Number(value || 0)?.toFixed(toFixedValue);
            await this.refreshModel(copyModel);
        }
    }

    splitInHalf = (fields = [], filter = false, target = '') => {
        const { view } = this.props
        const activeFields = fields?.filter(f => f.isHeader === filter);
        const middle = Math.ceil(activeFields?.length / 2);

        if (view === 'PurchaseRequest') {
            return {
                OPRQFieldsLeft: activeFields?.slice(0, middle),
                OPRQFieldsRight: activeFields?.slice(middle),
            };
        } else if (target === 'transferFields') {
            return {
                OWTRFieldsLeft: activeFields?.slice(0, middle),
                OWTRFieldsRight: activeFields?.slice(middle),
            };
        } else {
            return {
                invFLeft: activeFields?.slice(0, middle),
                invFRight: activeFields?.slice(middle),
            };
        }
    };

    renderSpecificFields = (fields = [], newOrderModel, action, editMode = false) =>
        fields.map(invField => (
            <div className="input-group mb-3" key={invField.Field}>
                <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold">
                        {invField.Name}
                    </span>
                </div>

                {(invField.Type === 'text' || invField.Type === 'number' || invField.Type === 'date') ? (
                    <input
                        type={invField.Type === 'number' ? 'text' : invField.Type}
                        className="form-control"
                        id={`${invField.Type}${invField.Field}`}
                        disabled={(Number(action) === 2 && !editMode) || invField.Static}
                        value={newOrderModel?.[invField.Field] ?? invField.emptyValue}
                        onChange={(e) => !invField.Static && this.changeHeaderField(invField.Field, e.target.value, invField?.Type === 'date' ? null : invField?.Size || null, invField?.isNumber || false)}
                        onBlur={(e) => invField?.isNumber && this.changeBlurHeaderField(invField.Field, e.target.value, 2)}
                    />
                ) :
                    <>
                        {invField.Type === 'select' ?
                            <>
                                <select
                                    className="form-control"
                                    id={`${invField.Type}${invField.Field}`}
                                    disabled={(Number(action) === 2 && !editMode) || invField.Static}
                                    value={newOrderModel?.[invField.Field] ?? invField.emptyValue}
                                    onChange={(e) => !invField.Static && this.changeHeaderField(invField.Field, e.target.value)}
                                >
                                    <option key={`dft-${invField.Type}`} value={invField.emptyValue || ''}> {`Seleccionar`}</option>
                                    {invField?.options?.map(row => (
                                        <option key={row.FldValue} value={row.FldValue}>
                                            {`${row.FldValue ?? ''} - ${row.Descr ?? ''}`}
                                        </option>
                                    ))}
                                </select>
                            </>
                            :
                            <>
                                {invField.Type === 'table' ?
                                    <>
                                        <input
                                            type={'text'}
                                            className="form-control"
                                            id={`${invField.Type}${invField.Field}`}
                                            disabled={true}
                                            onlyRead={true}
                                            value={newOrderModel?.[invField.Field] ?? invField.default}
                                        />
                                        {(Number(action) === 1 || (Number(action) === 2 && editMode)) && <>
                                            {(newOrderModel?.[invField.Field] && newOrderModel?.[invField.Field] !== invField.default) &&
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: '#c42222',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="input-group-text"
                                                    onClick={(e) => !invField.Static && this.changeHeaderField(invField.Field, invField.default)} >
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            }
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                disabled={(Number(action) === 2 && !editMode) || invField.Static}
                                                onClick={(e) => !invField.Static && this.openFormattedQueries(invField)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </>
                                        }
                                    </>
                                    :
                                    <>

                                    </>
                                }
                            </>
                        }
                    </>
                }
            </div>
        ));

    //FOOTER DE CREACION DE TRASLADO
    renderTransfersFooter = () => {
        const { newOrderModel, action } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Empleado de ventas:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Empleado ventas</span>
                        </div>
                        <input
                            className="form-control"
                            disabled
                            readOnly
                            value={newOrderModel.SlpName ? newOrderModel.SlpName : ""} />
                        {action == 1 && (
                            <button
                                type="button"
                                className="rounded-right btn btn-outline-warning"
                                onClick={this.openEmployee}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Comentarios</span>
                        </div>
                        <textarea
                            className="form-control styleTextarea"
                            placeholder="50 caracteres máximo"
                            disabled={action === 2}
                            value={newOrderModel.JrnlMemo || ""}
                            onChange={({ target: { value } }) => this.changeField("JrnlMemo", value, 50)} />
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-sm" style={{ paddingRight: 0 }}>
                    {newOrderModel.OriginDocumentCreate === "transfers" &&
                        <div className="input-group mb-3"> {/* Peso Total */}
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Peso Total </span>
                            </div>
                            <input
                                className="form-control text-right"
                                disabled
                                readOnly
                                value={FORMAT_NUMBER.new(newOrderModel.WeightTotal || 0, "", 3)} />
                        </div>
                    }
                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Comentarios</span>
                        </div>
                        <textarea
                            className="form-control styleTextarea"
                            placeholder="250 caracteres máximo"
                            disabled={action === 2}
                            value={newOrderModel.Comments || ""}
                            onChange={({ target: { value } }) => this.changeField("Comments", value, 254)} />
                    </div>
                </div>
            </div>
        );
    }

    checkWithHolding = (newOrderModel = {}) => {
        return newOrderModel;
    }

    checkItemPrices = async (changeDireciton = false, changePartner = false, changeTypeofSell = false, flagU_FMB_AttentionType = false, U_FMB_AttentionType = '', flagU_RS_TIPOV = false, U_RS_TIPOV = '') => {
        const { newOrderModel, showAlert, view, enableSpinner, getUserFieldHeaderValue } = this.props;
        let checkPrice = false;
        if (!newOrderModel?.CardCode
            || true  // Se coloco esto por reversa de listas de precios llamagas en transferencias 
        ) {
            return;
        }
        U_FMB_AttentionType = flagU_FMB_AttentionType ? U_FMB_AttentionType : getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel);
        U_RS_TIPOV = flagU_RS_TIPOV ? U_RS_TIPOV : getUserFieldHeaderValue('U_RS_TIPOV', newOrderModel);
        for (let index = 0; index < newOrderModel?.Items?.length; index++) {
            let newItemModel = newOrderModel?.Items[index];
            let searchItem = newItemModel?.ItemCode;
            const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

            if (newItemModel?.isTemporary || !searchItem || (!envasado && !glpGranel)) {
                continue;
            }

            if (!newOrderModel?.Filler) {
                showAlert({ type: 'warning', message: `Es necesario seleccionar el almacén origen para obtener el precio del artículo ${newItemModel?.ItemCode || newItemModel.ItemName}`, timeOut: 5000 });
                continue;
            }

            let getItemResponse = null;
            let data = {
                CardCode: newOrderModel?.CardCode || "",
                ItemCode: searchItem || "",
                WhsCode: newOrderModel?.Filler || "",
                ShipToCode: newOrderModel?.ShipToCode || "",
                userFields: newOrderModel?.userFields || {},
                Quantity: newItemModel?.Quantity || 0,
                U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                U_RS_UMED: newItemModel?.U_RS_UMED || "",
                U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                gallonsPrice: true,
            };

            //#region GALLON PRICE
            enableSpinner(true);
            let getItemGallonResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);
            const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
            data.U_RS_PRECIOGL = U_RS_PRECIO;
            data.gallonsPrice = false;
            //#endregion GALLON PRICE

            enableSpinner(true);
            getItemResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);

            const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
            const item = newItemModel || {};
            item.Price = U_RS_CALCULADO;
            checkPrice = true;

            if (glpGranel) {
                newItemModel.U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0).toFixed(priceDecimalPrecision));
                newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
            }

            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                newItemModel.HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                newItemModel.Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

            } else {
                newItemModel.HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                newItemModel.Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
            }

            newItemModel.newHomePrice = item.Price || 0;
            newItemModel.newPrice = item.Price || 0;
            newItemModel.cHomePrice = item.Price || 0;
            newItemModel.cPrice = item.Price || 0;
            if (glpGranel && newItemModel?.U_RS_UMED === 'GLN' && Number(newItemModel?.U_RS_CANTG) > 0) {
                newItemModel = await this.checkGallons(newItemModel, index, newOrderModel?.Filler)
            } else {
                if (getItemResponse?.status === 1) {
                    showAlert({ type: 'info', message: `El precio del artículo ${searchItem || newItemModel?.ItemName || ''} ha sido ajustado al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : 'el Tipo de Atención'}.`, timeOut: 5000 });
                } else {
                    showAlert({ type: 'error', message: `No se pudo determinar el precio del artículo ${searchItem || newItemModel?.ItemName || ''} al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : 'el Tipo de Atención'}.`, timeOut: 5000 });
                }
            }
        }
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        }
    }
    selectBinLocation = (value) => {
        const { newOrderModel } = this.props
        $("#sucursalLocationsModal").modal("hide");
        this.setState({
            listBinLocations: [],
            showBinLocationsModal: false,
        })
        newOrderModel.U_FMB_ID_RUTA = value?.CodigoAutotransporte ?? null;
        newOrderModel.U_AbsEntry = value?.AbsEntry ?? null;
        newOrderModel.U_FMB_BinLocationTr = value?.BinCode ?? null;

        this.refreshModel(newOrderModel);
        this.fillTransportData();
    }
    fillTransportData = async () => {
        const { newOrderModel, showAlert, enableSpinner } = this.props
        if (!newOrderModel.U_FMB_ID_RUTA) {
            return showAlert({ type: 'warning', message: "Seleccione un transporte" });
        }
        const search = {
            id: newOrderModel.U_FMB_ID_RUTA,
            invFields: newOrderModel?.invFields ?? null
        }

        enableSpinner(true);
        let responseApi = await apiClient.transportData(search);
        enableSpinner(false);
        if (responseApi?.status === SERVICE_RESPONSE.SUCCESS) {
            const copyModel = JSON.parse(JSON.stringify(newOrderModel))
            const transportData = responseApi?.data ?? null
            Object.entries(transportData || {}).forEach(([key, value]) => {
                copyModel[key] = value ?? null;

            });
            await this.refreshModel(copyModel);
        } else {
            return showAlert({ type: 'warning', message: responseApi?.message ?? 'Error de conexión' });
        }
    }

    returnValueItem = (FieldID, index) => {
        const { newOrderModel } = this.props;
        let value = "";
        switch (FieldID) {
            case 0:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields1 : "";
                break;
            case 1:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields2 : "";
                break;
            case 2:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields3 : "";
                break;
            case 3:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields4 : "";
                break;
            case 4:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields5 : "";
                break;
            case 5:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields6 : "";
                break;
            case 6:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields7 : "";
                break;
            case 7:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields8 : "";
                break;
            case 8:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields9 : "";
                break;
            case 9:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields10 : "";
                break;
            case 10:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields11 : "";
                break;
            case 11:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields12 : "";
                break;
            case 12:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields13 : "";
                break;
            case 13:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields14 : "";
                break;
            case 14:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields15 : "";
                break;
            case 15:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields16 : "";
                break;
            case 16:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields17 : "";
                break;
            case 17:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields18 : "";
                break;
            case 18:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields19 : "";
                break;
            case 19:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields20 : "";
                break;
            case 20:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields21 : "";
                break;
            case 21:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields22 : "";
                break;
            case 22:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields23 : "";
                break;
            case 23:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields24 : "";
                break;
            case 24:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields25 : "";
                break;
            case 25:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields26 : "";
                break;
            case 26:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields27 : "";
                break;
            case 27:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields28 : "";
                break;
            case 28:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields29 : "";
                break;
            case 29:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields30 : "";
                break;
            case 30:
                value = newOrderModel.userFieldsItem ? newOrderModel.Items[index].UserFieldsItem.userFields31 : "";
                break;

            default:
                break;

        }

        return value;
    }

    changeUserFieldsItemsDocument = async (event, IdValue, index) => {
        const { refreshModel, view } = this.props;
        let { newOrderModel } = this.props;
        switch (IdValue) {
            case 0:
                newOrderModel.Items[index].UserFieldsItem.userFields1 = event.nativeEvent.target.value;
                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    const parentLineNum_3 = newOrderModel.Items[index].LineNum;
                    if (newOrderModel.Items[index].isAdministrativeExpenseParent) {
                        newOrderModel.Items = newOrderModel.Items.filter(
                            item => item.ParentLineNum !== parentLineNum_3
                        );
                    }
                }
                break;
            case 1:
                newOrderModel.Items[index].UserFieldsItem.userFields2 = event.nativeEvent.target.value;

                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    const parentLineNum = newOrderModel.Items[index].LineNum;

                    if (newOrderModel.Items[index].isAdministrativeExpenseParent) {
                        newOrderModel.Items = newOrderModel.Items.filter(
                            item => item.ParentLineNum !== parentLineNum
                        );
                    }

                    newOrderModel.Items[index].isAdministrativeExpenseParent = '';

                    if (Number(event.nativeEvent.target.value) === 1) {
                        await this.SearchAdministrativeExpenses(newOrderModel.Items[index]);
                    }
                }
                break;
            case 2:
                newOrderModel.Items[index].UserFieldsItem.userFields3 = event.nativeEvent.target.value;

                if (view === 'invoice' || view === 'deliveries' || (view === 'orderSales' && (newOrderModel?.OriginDocumentCreate === 'invoice' || newOrderModel?.OriginDocumentCreate === 'deliveries'))) {
                    if (newOrderModel.Items[index].UserFieldsItem.userFields3.indexOf(" ") !== -1 || newOrderModel.Items[index].UserFieldsItem.userFields3.indexOf("-") !== -1) {
                        break;
                    }
                    const parentLineNum_1 = newOrderModel.Items[index].LineNum;
                    const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum_1);

                    childItems.forEach(child => {
                        child.Quantity = Number(newOrderModel.Items[index].Quantity) - Number(event.nativeEvent.target.value);
                    });
                }
                break;
            case 3:
                newOrderModel.Items[index].UserFieldsItem.userFields4 = event.nativeEvent.target.value;
                if (newOrderModel.isPurchaseDocument && (newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder')) {
                    newOrderModel = await this.checkWithHolding(newOrderModel);
                }
                break;
            case 4:
                newOrderModel.Items[index].UserFieldsItem.userFields5 = event.nativeEvent.target.value;
                break;
            case 5:
                newOrderModel.Items[index].UserFieldsItem.userFields6 = event.nativeEvent.target.value;
                break;
            case 6:
                newOrderModel.Items[index].UserFieldsItem.userFields7 = event.nativeEvent.target.value;
                break;
            case 7:
                newOrderModel.Items[index].UserFieldsItem.userFields8 = event.nativeEvent.target.value;
                break;
            case 8:
                newOrderModel.Items[index].UserFieldsItem.userFields9 = event.nativeEvent.target.value;
                break;
            case 9:
                newOrderModel.Items[index].UserFieldsItem.userFields10 = event.nativeEvent.target.value;
                break;
            case 10:
                newOrderModel.Items[index].UserFieldsItem.userFields11 = event.nativeEvent.target.value;
                break;
            case 11:
                newOrderModel.Items[index].UserFieldsItem.userFields12 = event.nativeEvent.target.value;
                break;
            case 12:
                newOrderModel.Items[index].UserFieldsItem.userFields13 = event.nativeEvent.target.value;
                break;
            case 13:
                newOrderModel.Items[index].UserFieldsItem.userFields14 = event.nativeEvent.target.value;
                break;
            case 14:
                newOrderModel.Items[index].UserFieldsItem.userFields15 = event.nativeEvent.target.value;
                break;
            case 15:
                newOrderModel.Items[index].UserFieldsItem.userFields16 = event.nativeEvent.target.value;
                break;
            case 16:
                newOrderModel.Items[index].UserFieldsItem.userFields17 = event.nativeEvent.target.value;
                break;
            case 17:
                newOrderModel.Items[index].UserFieldsItem.userFields18 = event.nativeEvent.target.value;
                break;
            case 18:
                newOrderModel.Items[index].UserFieldsItem.userFields19 = event.nativeEvent.target.value;
                break;
            case 19:
                newOrderModel.Items[index].UserFieldsItem.userFields20 = event.nativeEvent.target.value;
                break;
            case 20:
                newOrderModel.Items[index].UserFieldsItem.userFields21 = event.nativeEvent.target.value;
                break;
            case 21:
                newOrderModel.Items[index].UserFieldsItem.userFields22 = event.nativeEvent.target.value;
                break;
            case 22:
                newOrderModel.Items[index].UserFieldsItem.userFields23 = event.nativeEvent.target.value;
                break;
            case 23:
                newOrderModel.Items[index].UserFieldsItem.userFields24 = event.nativeEvent.target.value;
                break;
            case 24:
                newOrderModel.Items[index].UserFieldsItem.userFields25 = event.nativeEvent.target.value;
                break;
            case 25:
                newOrderModel.Items[index].UserFieldsItem.userFields26 = event.nativeEvent.target.value;
                break;
            case 26:
                newOrderModel.Items[index].UserFieldsItem.userFields27 = event.nativeEvent.target.value;
                break;
            case 27:
                newOrderModel.Items[index].UserFieldsItem.userFields28 = event.nativeEvent.target.value;
                break;
            case 28:
                newOrderModel.Items[index].UserFieldsItem.userFields29 = event.nativeEvent.target.value;
                break;
            case 29:
                newOrderModel.Items[index].UserFieldsItem.userFields30 = event.nativeEvent.target.value;
                break;
            case 30:
                newOrderModel.Items[index].UserFieldsItem.userFields31 = event.nativeEvent.target.value;
                break;

            default:
                break
        }
        refreshModel(newOrderModel);
    };

    //#region GALLONS CONVERSION
    changeUserUM = async (index, event) => {
        const { newOrderModel, showAlert, view, enableSpinner } = this.props;
        let newView = newOrderModel?.newView || view;

        newOrderModel.Items[index].U_RS_UMED = event?.target?.value || '';
        let checkPrice = false;
        //#region Precio Llamagas
        // if (newOrderModel?.isTransferDocument) {
        if (false) {
            const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_CANTG = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
            const envasado = Envasados?.includes(Number(ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(ItmsGrpCod));
            let searchItem = ItemCode;

            if (!isTemporary && searchItem && (envasado || glpGranel)) {
                let getItemResponse = null;
                const data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: searchItem || "",
                    WhsCode: newOrderModel?.Filler || "",
                    ShipToCode: newOrderModel?.ShipToCode || "",
                    userFields: newOrderModel?.userFields || {},
                    Quantity,
                    U_RS_CANTG,
                    U_RS_UMED,
                    U_RS_PRECIOGL,
                    gallonsPrice: true,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                //#endregion GALLON PRICE

                enableSpinner(true);
                getItemResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);

                const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                const item = newOrderModel.Items[index] || {};
                item.Price = U_RS_CALCULADO;
                checkPrice = true;

                if (glpGranel) {
                    newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                    newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                }

                let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                    newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                } else {
                    newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                    newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                }

                newOrderModel.Items[index].newHomePrice = item.Price || 0;
                newOrderModel.Items[index].newPrice = item.Price || 0;
                newOrderModel.Items[index].cHomePrice = item.Price || 0;
                newOrderModel.Items[index].cPrice = item.Price || 0;
                if (getItemResponse?.status === 1) {
                    showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la unidad de medida.', timeOut: 5000 });
                } else {
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la unidad de medida.', timeOut: 5000 });
                }
            }
        }
        //#endregion Precio Llamagas
        if (checkPrice) {
            await this.refreshTotal(newOrderModel);
        } else {
            await this.refreshModel(newOrderModel);
        }
        if (newView !== 'transfersEntry') {
            if (!newOrderModel.Items[index].U_RS_UMED || newOrderModel.Items[index].U_RS_UMED === 'KGM') {
                let cantG = false
                if (Number(newOrderModel.Items[index].U_RS_CANTG) > 0 && newOrderModel.Items[index]?.Gallons) {
                    cantG = true;
                }
                // newOrderModel.Items[index].U_RS_DENS = 0;
                newOrderModel.Items[index].U_RS_CANTG = 0;
                newOrderModel.Items[index].U_RS_TOTALGL = 0;
                newOrderModel.Items[index].Gallons = false;
                await this.refreshModel(newOrderModel);
                setTimeout(async () => {
                    if (cantG) {
                        await this.validateQty(index, Number(1), newOrderModel.Items[index]?.Gallons)
                        showAlert({ type: 'info', message: `La cantidad y precio del artículo ${newOrderModel.Items[index]?.ItemCode} ha sido ajustada al quitar la conversión de galones.` });
                    }
                }, 100);
            } else if (newOrderModel.Items[index].U_RS_UMED === 'GLN' && Number(newOrderModel.Items[index].U_RS_CANTG) > 0) {
                newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index, newOrderModel?.Filler)
                await this.refreshModel(newOrderModel);
                if (newOrderModel.Items[index]?.Gallons) {
                    setTimeout(async () => {
                        await this.validateQty(index, Number(newOrderModel.Items[index]?.Quantity || 0), newOrderModel.Items[index]?.Gallons)
                    }, 100);
                }
            }
        }
    };

    normalizeNumber = (value) => {
        value = String(value ?? "").replace(/[^0-9.]/g, "");

        if (value.includes(".")) {
            const [i, d] = value.split(".");
            return `${i}.${d}`;
        }
        if (value.startsWith(".")) {
            return `0${value}`;
        }
        return value;
    };

    changeGalonesCant = async (index, event) => {
        const { newOrderModel } = this.props;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.Items[index].U_RS_CANTG = value;
        await this.refreshModel(newOrderModel);
    };

    changeQuantityBlur = async (index, event, field = '') => {
        if (!field) {
            return;
        };
        const { newOrderModel, view, enableSpinner, showAlert } = this.props;
        let newView = newOrderModel?.newView || view;
        if (newView !== 'transfersEntry') {
            newOrderModel.Items[index][field] = Number(Number(event?.nativeEvent?.target?.value || 0)?.toFixed(3));

            let U_RS_CANTG = field === 'U_RS_CANTG' ? Number(newOrderModel.Items[index][field]) : Number(newOrderModel.Items[index].U_RS_CANTG);
            newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));

            let checkPrice = false;
            if (field === 'U_RS_CANTG') {
                //#region Precio Llamagas
                // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument)) {
                if ((newOrderModel?.isSalesDocument)) {
                    const { ItmsGrpCod, ItemCode = '', WhsCode = '', Quantity = 0, U_RS_UMED = 0, U_RS_PRECIOGL = 0, isTemporary = false } = newOrderModel.Items[index] ?? {}
                    const envasado = Envasados?.includes(Number(ItmsGrpCod));
                    const glpGranel = Granel?.includes(Number(ItmsGrpCod));
                    let searchItem = ItemCode;

                    if (!isTemporary && searchItem && (envasado || glpGranel)) {
                        let getItemResponse = null;
                        let data = {
                            CardCode: newOrderModel?.CardCode || "",
                            ItemCode: searchItem || "",
                            WhsCode: newOrderModel?.Filler || "",
                            ShipToCode: newOrderModel?.ShipToCode || "",
                            userFields: newOrderModel?.userFields || {},
                            Quantity,
                            U_RS_CANTG,
                            U_RS_UMED,
                            U_RS_PRECIOGL,
                            gallonsPrice: true,
                        };

                        //#region GALLON PRICE
                        enableSpinner(true);
                        let getItemGallonResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);
                        const U_RS_PRECIO = getItemGallonResponse?.status === 1 ? Number(getItemGallonResponse?.data?.U_RS_PRECIO || 0) : 0;
                        data.U_RS_PRECIOGL = U_RS_PRECIO;
                        data.gallonsPrice = false;
                        //#endregion GALLON PRICE

                        enableSpinner(true);
                        getItemResponse = await apiClient.getPriceListLlama(data);
                        enableSpinner(false);

                        const U_RS_CALCULADO = getItemResponse?.status === 1 ? Number(getItemResponse?.data?.U_RS_CALCULADO || 0) : 0;
                        const item = newOrderModel.Items[index] || {};
                        item.Price = U_RS_CALCULADO;
                        checkPrice = true;

                        if (glpGranel) {
                            newOrderModel.Items[index].U_RS_PRECIOGL = Number(parseFloat(U_RS_PRECIO || 0)?.toFixed(priceDecimalPrecision));
                            newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                        }

                        let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                        if (newOrderModel?.isTransferDocument || view === 'GoodsReceipt' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') {
                            newOrderModel.Items[index].HomePrice = parseFloat(item.Price).toFixed(priceDecimalPrecision);
                            newOrderModel.Items[index].Price = parseFloat(item.Price).toFixed(priceDecimalPrecision);

                        } else {
                            newOrderModel.Items[index].HomePrice = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                            newOrderModel.Items[index].Price = parseFloat(item.Price || 0).toFixed(priceDecimalPrecision) * Number(measureUnit);
                        }

                        newOrderModel.Items[index].newHomePrice = item.Price || 0;
                        newOrderModel.Items[index].newPrice = item.Price || 0;
                        newOrderModel.Items[index].cHomePrice = item.Price || 0;
                        newOrderModel.Items[index].cPrice = item.Price || 0;
                        if (getItemResponse?.status === 1) {
                            showAlert({ type: 'info', message: 'El precio del artículo ' + item.ItemCode + ' ha sido ajustado al cambiar la cantidad de galones.', timeOut: 5000 });
                        } else {
                            showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item.ItemCode + ' al cambiar la cantidad de galones.', timeOut: 5000 });
                        }
                    }
                }
                if (checkPrice) {
                    await this.refreshTotal(newOrderModel);
                }
                //#endregion Precio Llamagas
            }

            await this.refreshModel(newOrderModel);
            if (field === 'U_RS_CANTG') {
                newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index, newOrderModel?.Filler)
                await this.refreshModel(newOrderModel);
                if (newOrderModel.Items[index]?.Gallons) {
                    setTimeout(async () => {
                        await this.validateQty(index, Number(newOrderModel.Items[index]?.Quantity || 0), newOrderModel.Items[index]?.Gallons);
                    }, 100);
                }
            }
        } else {
            newOrderModel[field] = Number(Number(event?.nativeEvent?.target?.value || 0)?.toFixed(3));
            await this.refreshModel(newOrderModel);
        }
    };

    checkGallons = async (item, index, Filler = '') => {
        const { enableSpinner, showAlert } = this.props;

        if (!item?.U_RS_UMED ||
            // !item?.WhsCode ||
            !Filler ||
            !item?.ItemCode || item?.U_RS_UMED !== 'GLN' || (Number(item?.U_RS_CANTG || 0) === 0) || (!Granel?.includes(Number(item?.ItmsGrpCod)))) {
            return item;
        };
        let checkItem = {
            ItemCode: item.ItemCode,
            U_RS_UMED: item.U_RS_UMED,
            // U_RS_DENS: item.U_RS_DENS,
            U_RS_CANTG: item.U_RS_CANTG,
            // WhsCode: item.WhsCode
            WhsCode: Filler
        }
        enableSpinner(true);
        let gallons = await apiClient.getGallonsConversion(checkItem);
        enableSpinner(false);
        item.Gallons = true;
        if (gallons?.status && gallons?.data) {
            item.Quantity = Number(gallons.data?.Quantity || 0);
            showAlert({ type: 'info', message: `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        } else {
            item.Quantity = 0;
            showAlert({ type: 'warning', message: gallons?.message || `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        }
        return item;
    }

    emptyField = () => {
        return (
            <td style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    className="form-control btn-outline-secondary"
                    disabled={true}
                    readOnly={true}
                    style={{
                        backgroundColor: 'transparent',
                        borderColor: '#ced4da',
                        color: '#000',
                        paddingTop: 1,
                        paddingBottom: 2,
                        minWidth: 80,
                        textAlign: "center",
                    }}
                    value={''}
                />
            </td>
        )
    }
    //#endregion GALLONS CONVERSION

    openAddresses = async type => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        if (!newOrderModel.CardCode && !newOrderModel.CardName) {
            showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
            return;
        }

        if (newOrderModel.Addresses.length > 0) {
            $('#addressesModal').modal('show');
            return;
        }
        enableSpinner(true);
        let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
        enableSpinner(false);

        let data = [];
        if (type === 1) {
            if (getAddressResponse.data.deliveriesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }

            data = getAddressResponse.data.deliveriesAddress;
        } else {
            if (getAddressResponse.data.invoicesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            data = getAddressResponse.data.invoicesAddress;
        }

        newOrderModel.Addresses = data;
        this.setState({
            newOrderModel,
        });

        $('#addressesModal').modal('show');

    };

    selectAddresses = async (action) => {
        const { newOrderModel } = this.props;
        const address = newOrderModel.Addresses[action.index];

        newOrderModel.ShipToCode = address.Address;
        newOrderModel.Address = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";

        await this.refreshModel(newOrderModel);
        $('#addressesModal').modal('hide');

        //#region Precio Llamagas
        // if (newOrderModel?.isTransferDocument) { // Al cambiar dirección consultar precios
        if (false) { // Al cambiar dirección consultar precios
            setTimeout(() => {
                this.checkItemPrices(true);
            }, 500);
        }
        //#endregion Precio Llamagas
    };

    openCentroCoste = async (index, centro) => {
        const { showAlert, enableSpinner } = this.props;
        enableSpinner(true);
        let getCentroCosteResponse = await apiClient.getCentroCosteList(centro);
        enableSpinner(false);

        if (!Array.isArray(getCentroCosteResponse?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getCentroCosteResponse?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            centroCostes: getCentroCosteResponse?.data,
            itemOrderModelUpdate: index,
            centroCosteId: centro,
        }, () => {
            $('#CentroCoste').modal('show');
        });
    };

    selectCentroCoste = action => {
        const { centroCostes, itemOrderModelUpdate, centroCosteId } = this.state;
        const { newOrderModel, view } = this.props;
        let centroCoste = centroCostes[action.index];

        let docType = newOrderModel.DocType;
        switch (centroCosteId) {
            case 1:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                }

                break;
            case 2:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                }

                break;
            case 3:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                }

                break;
            case 4:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                }

                break;
            case 5:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                }

                break;
            default:
        }

        this.refreshModel(newOrderModel);
        $('#CentroCoste').modal('hide');
        setTimeout(() => {
            this.setState({
                centroCostes: [],
            });
        }, 100);
    };

    render() {
        const { action, view, newOrderModel, showAlert, enableSpinner, openConfigUserFieldsHeaders, configHeaderUserFields, writeAccess, setWhsByRouteDocs, getDimension1ByUserField } = this.props;
        const { isSelectTo, isSelectOf } = newOrderModel;
        const {
            partners,
            contacts,
            warehouses,
            items,
            employees,
            series,
            editMode,
            partnerType,
            pageTotal,
            indexPurchaseRequest,
            itemSelected,
            enableTransfersList,
            showLocationAssignment,
            optionLocation,
            lineNumLocation,
            locations,
            showListLocationsModal,
            showBinLocationsModal,
            listBinLocations,
            showFormattedQueriesModal,
            formattedInfo = {},
            centroCostes = [],
        } = this.state;

        let auxiModel = { CardCode: "" }

        const type = action === 1 ? "Nuevo(a)" : "Detalle de";
        let title = "";

        switch (newOrderModel.OriginDocumentCreate) {
            case "transfers": title = `${type} Traslado de Mercancía`; break;
            case "transfersRequest": title = `${type} Solicitud de Traslado`; break;
            default: title = ""; break;
        }

        return (
            <>
                <div className="modal fade" id="TransfersDocumentModal" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content" id="printThis">
                            <div className="modal-header text-white" style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                                <h4 className="modal-title" id="modal-basic-title "> {title} </h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true"> &times; </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <div className="text-right">
                                                <label className="mr-2 mb-0" htmlFor="btnUDF">
                                                    <span className="d-none d-xl-inline font-weight-bold">Campos de Usuario</span>
                                                    <span className="d-inline d-xl-none font-weight-bold">Campos Usuario</span>
                                                </label>
                                                <button
                                                    id="btnUDF"
                                                    type="button"
                                                    className="btn btn-outline-warning border-0"
                                                    onClick={this.openUserFields}>
                                                    <i className="fa fa-list" />
                                                </button>
                                            </div>
                                            {newOrderModel.ShowBatchInfo && action === 2 &&
                                                <div>
                                                    <label className="mr-2 mb-0" htmlFor="btnUDF">
                                                        <span className="d-none d-xl-inline font-weight-bold">Campos de Usuario</span>
                                                        <span className="d-inline d-xl-none font-weight-bold">Campos Usuario</span>
                                                    </label>
                                                    <button
                                                        className="btn btn-outline-secondary border-0"
                                                        onClick={this.OpenBatchReportModal} >
                                                        <i className="fa fa-hashtag" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {this.renderDocumentTransfersHeader()}
                                    {this.renderDocumentTransfersBody()}
                                    {this.renderTransfersFooter()}
                                </div>
                            </div>

                            <div className="modal-footer">
                                {Number(action) === 2 && !editMode && writeAccess && (!isSelectTo || !isSelectOf) && (view === "transfersRequest") && (newOrderModel.Items.length === 0) &&
                                    <select className="botonCorrect text-white" value={"--"} onChange={this.selectTo}>
                                        <option value="--">Copiar a ...</option>
                                        <option value="transfers">Traslado de Mercancía</option>
                                    </select>
                                }

                                {Number(action) === 1 && writeAccess && (!isSelectTo || !isSelectOf) && (view === "transfers") && (newOrderModel.Items.length === 0) &&
                                    <select className="btn botonCorrect text-white" value={"--"} onChange={({ target: { value } }) => this.selectOf(value)}>
                                        <option value="--">Copiar de ...</option>
                                        <option value="transfersRequest">Solicitud de Traslado</option>
                                    </select>
                                }

                                {Number(action) === 1 && writeAccess &&
                                    <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}> Crear </button>
                                }
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                            </div>
                        </div>
                    </div>
                </div>
                {showBinLocationsModal && <StandardSelectModal
                    id="sucursalLocationsModal"
                    title={"TRANSPORTES"}
                    headers={[
                        { title: "Ubicación", value: true, filter: true, field: "BinCode" },
                    ]}
                    data={listBinLocations ?? []}
                    selectAction={this.selectBinLocation}
                    selectedItems={[]}
                    disabled={false}
                    idSelection="BinCode"
                    validNoSelection={true} />}

                <UserFieldsModal
                    newOrderModel={newOrderModel}
                    action={action}
                    refreshModel={this.refreshModel}
                    view={view}
                    hanldeUserFields={this.hanldeUserFields}
                    newView={newOrderModel.newView}
                    editMode={editMode}
                    openConfigUserFieldsHeaders={openConfigUserFieldsHeaders}
                    configHeaderUserFields={configHeaderUserFields}
                    setWhsByRouteDocs={setWhsByRouteDocs}
                    getDimension1ByUserField={getDimension1ByUserField}
                    checkWithHolding={this.checkWithHolding}
                    checkItemPrices={this.checkItemPrices}
                    enableSpinner={enableSpinner}
                    showAlert={showAlert}
                />

                <PartnerCreateModal
                    data={partners}
                    type={partnerType}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    selectPartner={this.selectPartner}
                    cleanData={() => this.setState({ partners: [] })}
                    refreshPartner={this.refreshPartner}
                    indexPurchaseRequest={indexPurchaseRequest} />

                <PersonContactModal
                    data={contacts}
                    selectContact={this.selectContact}
                    cleanData={() => this.setState({ contacts: [] })} />

                <AlmacenModal
                    data={warehouses}
                    view={view}
                    itemSelected={itemSelected}
                    selectAlmacen={this.selectAlmacen}
                    cleanData={() => this.setState({ warehouses: [], itemSelected: "" })} />

                <EmployeeSalesModal
                    data={employees}
                    selectEmployee={this.selectEmployee}
                    cleanData={() => this.setState({ employees: [] })} />

                <ItemsCreateModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    mainView={view}
                    selectItems={this.selectItems}
                    cleanData={() => this.setState({ items: [] })}
                    refreshItems={this.refreshItems} />

                <SeriesCreateModal
                    data={series}
                    selectSerie={this.selectSeries}
                    cleanData={() => this.setState({ series: [] })} />

                <SelectOfModal
                    showAlert={showAlert}
                    enableSpinner={enableSpinner}
                    newOrderModel={newOrderModel}
                    addItem={this.selectOfDocuments}
                    view={view}
                    ref={(ref) => this.selectOfReference = ref} />

                {enableTransfersList &&
                    <ListPartnerModal
                        data={this.state.transfersListCEDIS}
                        modalView={"T"}
                        totalPage={pageTotal}
                        model={auxiModel}
                        cleanData={() => this.setState({
                            transfersListCEDIS: [],
                            partners: [],
                            invoices: [],
                            checkboxArray: (new Map())
                        })}
                        selectPartner={this.selectPartner}
                        type={partnerType}
                        selectItems={this.SaveCheckBoxTransfers}
                        selectItemsToArray={this.selectItemsToArray}
                        checkboxArray={this.state.checkboxArray}
                        refreshPartner={this.refreshPartner}
                        showAlert={showAlert}
                        search={this.searchDocuments} />
                }

                {showLocationAssignment &&
                    <LocationAssignment
                        newOrderModel={newOrderModel}
                        option={optionLocation}
                        lineNumLocation={lineNumLocation}
                        CleanData={() => this.setState({ showLocationAssignment: false, showListLocationsModal: false })}
                        openLocations={this.openLocations}
                        changeSearchLocations={this.changeSearchLocations}
                        locations={locations}
                        pageTotal={pageTotal}
                        cleanData={() => this.setState({ locations: [] })}
                        showListLocationsModal={showListLocationsModal}
                        refreshLocations={this.refreshLocations}
                        selectLocation={this.selectLocationsEnter}
                        updateModel={this.refreshModel}
                        showAlert={showAlert} />
                }

                {showFormattedQueriesModal &&
                    <FormattedQueriesModal
                        formattedInfo={formattedInfo}
                        formattedMap={newOrderModel?.formattedMap}
                        view={view}
                        selectFormattedQueries={this.selectFormattedQueries}
                        cleanData={() => this.setState({ formattedInfo: {}, showFormattedQueriesModal: false })}
                    />
                }

                <AddressesModal
                    data={newOrderModel.Addresses}
                    selectAddresses={this.selectAddresses}
                    edditAddres={this.edditAddres}
                    cleanData={() => { }}
                />

                <CentroCosteModal
                    data={centroCostes}
                    selectCentroCoste={this.selectCentroCoste}
                    cleanData={() => this.setState({ centroCostes: [] })}
                />
            </>
        );
    }
}

export default TransfersDocumentModal;